import {environment} from '@environments/environment';
import {AutoGrowTextareaDirective} from './auto-grow-textarea.directive';
import {SbPremiumBadgeComponent} from '@app/_components/unified/sb-premium/sb-premium-badge.component';
import {SbPremiumLockComponent} from '@app/_components/unified/sb-premium/sb-premium-lock.component';
import {IframeModalShellComponent} from '@app/_components/iframe-modal-shell/iframe-modal-shell.component';
import {FileBrowserComponent} from '@app/_components/file-browser/file-browser.component';
import {SettingsService} from '@app/services/settings.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ChangeDetectionStrategy, inject, viewChild, viewChildren } from '@angular/core';
import {Router} from '@angular/router';
import {TemplateGeneratorService} from '@app/services/template-generator.service';
import {SegmentApiService} from '@app/services/api/segment-api.service';
import * as routes from '@app/routes';
import {select, Store} from '@ngrx/store';
import {
  CampaignGetAllPaginate,
  CampaignUpdateError,
  CampaignUpdateSuccess,
  CampaignWidgetPreviewURL,
  getCampaignUpdate,
  getCampaignWidgetPreviewUrl,
  getFileUploadProgress,
  getInfluencersProjectSegment,
  getInfluencersTypes,
  getLoggedInUser,
  getPaginatedCampaigns,
  getSignedUrl,
  getSignedUrlError,
  getUploadToSignedUrl,
  getUploadToSignedUrlError,
  getWidgetAvatarTemplates,
  getToken,
  IAuthenticationState,
  ICampaignState,
  IFileUploadState, IInfluencersState, InfluencersProjectSegment, InfluencersTypeList, ITemplateState,
  IVariableState,
  ResetFileState,
  SignedUrl,
  UploadToSignedUrl,
  WidgetAvatarTemplateListAll
} from '@app/stores';
import {lastValueFrom, Observable} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import {catchError, map, takeUntil} from 'rxjs/operators';
import {of, Subject} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {SocketService} from '@app/services/socket.service';
import * as _ from 'lodash';
import {ImageCropperDialogComponent} from '@app/modules/image-cropper-dialog/image-cropper-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {CampaignService} from '@app/services/campaign.service';
import {WidgetAvatarTemplatesComponent} from '@app/modules/project/widget-avatar-templates/widget-avatar-templates.component';
import {NgbModalRef, NgbModal, NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import { InfluencerType } from '@app/modules/shared/models';
import { CdkDragDrop, moveItemInArray, CdkDropListGroup, CdkDropList, CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InfluencerService } from '@app/services/influencer.service';
import { AwsService } from '@app/services/aws.service';
import { CampaignSharePresetService } from '@app/services/campaign-share-preset.service';
import { ThemeService } from '@app/services/theme.service';
import Swal from 'sweetalert2';
import {WIDGET_HEADER_DESCRIPTIONS, WIDGET_HEADER_TEXT_EDITOR_CONFIG, WIDGET_TEXT_EDITOR_CONFIG, WidgetHeaderKey, WidgetTextEditorConfig, widgetHeaderNotLiveNote, widgetHeaderPlaceholder} from '@app/modules/shared/widget-text-editor-config';
import {SbRichTextComponent} from '@app/_components/unified/sb-rich-text/sb-rich-text.component';
import {toolsFromToolbarGroups} from '@app/_components/unified/sb-rich-text/sb-rich-text-tools';
import {CanComponentDeactivateWithPendingSave} from '@app/_guards/pending-save.guard';
import {hasVariableToken} from '@app/_helpers/variable-tokens';
import {startPanelResize} from '@app/_helpers/panel-resize';
import {SbTextConditionService} from '@app/_components/unified/sb-text-condition/sb-text-condition.service';
import type {TextConditionContext} from '@app/_components/unified/sb-text-condition/sb-text-condition.service';
import {TemplateService} from '@app/services/template.service';
import {VIDEO_TEMPLATE_TYPE_ID} from '@app/consts';
import { CreatableSelectComponent } from '../../../_components/creatable-select/creatable-select.component';
import { DragBoxDirective } from './drag-box.directive';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { VariablesComponent } from '../../../_components/variables/variables.component';
import { SbTextConditionButtonComponent } from '../../../_components/unified/sb-text-condition/sb-text-condition-button.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SbTextConditionHintComponent } from '../../../_components/unified/sb-text-condition/sb-text-condition-hint.component';
import { Dir } from '@angular/cdk/bidi';
import { InfoPopoverComponent } from '../../../_components/info-popover/info-popover.component';
import { SbInputLanguageComponent } from '../../../_components/unified/sb-select/sb-input-language.component';
import { SbInputSelectComponent } from '../../../_components/unified/sb-select/sb-select.component';
import { SbRichTextComponent as SbRichTextComponent_1 } from '../../../_components/unified/sb-rich-text/sb-rich-text.component';
import { FileBrowserComponent as FileBrowserComponent_1 } from '../../../_components/file-browser/file-browser.component';
import { ColorPickerDirective } from '../../shared/directives/colorPicker.directive';
import { IframeModalShellComponent as IframeModalShellComponent_1 } from '../../../_components/iframe-modal-shell/iframe-modal-shell.component';
import { StatusBarComponent } from '../../status-bar/status-bar.component';
import { PreviewInfluencerNavComponent } from '../preview-influencer-nav/preview-influencer-nav.component';
import {SbModalService} from '@app/_components/unified/sb-modal/sb-modal.service';

const WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY = 'widget_media_advanced_defaults';

@Component({
  selector: 'app-share-campaign.component',
  templateUrl: './share-campaign.component.html',
  styleUrls: ['./share-campaign.component.scss'],
  // The popovers and dialogs opened from this page's own templates (the rich text popovers, the
  // section, settings and preset dialogs) edit campaignMeta that the page shows. Their views are
  // not inside this one, but an event in them marks this page, and refreshing this page refreshes
  // them (onpush-template-overlays.spec.ts).
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'(document:click)': 'closeSharePresetSaveMenuOnOutsideClick()'},
  imports: [CdkDropListGroup, CreatableSelectComponent, DragBoxDirective, AutoGrowTextareaDirective, VariablesComponent, SbTextConditionButtonComponent, ReactiveFormsModule, FormsModule, SbTextConditionHintComponent, NgbPopover, Dir, NgTemplateOutlet, InfoPopoverComponent, SbInputLanguageComponent, SbRichTextComponent_1, CdkDropList, CdkDrag, CdkDragHandle, FileBrowserComponent_1, ColorPickerDirective, IframeModalShellComponent_1, StatusBarComponent, PreviewInfluencerNavComponent, AsyncPipe, SbInputSelectComponent, SbPremiumBadgeComponent, SbPremiumLockComponent]
})
export class ShareCampaignComponent implements OnInit, OnDestroy, AfterViewInit, CanComponentDeactivateWithPendingSave {
  private router = inject(Router);
  private segmentsApiService = inject(SegmentApiService);
  private templateGeneratorService = inject(TemplateGeneratorService);
  private variableStore = inject<Store<IVariableState>>(Store);
  private campaignStore = inject<Store<ICampaignState>>(Store);
  private influencerStore = inject<Store<IInfluencersState>>(Store);
  private loaderService = inject(LoaderService);
  private fileUploadStore = inject<Store<IFileUploadState>>(Store);
  private toastr = inject(ToastrService);
  private socketService = inject(SocketService);
  private readonly dialog = inject(MatDialog);
  // The page keeps its settings in large plain objects, edited in place all over the template;
  // every async write below (store, socket, requests, timers, dialogs' promises, frame messages)
  // marks the view, which is what refreshes it without zone.js.
  private readonly cdr = inject(ChangeDetectorRef);
  private campaignService = inject(CampaignService);
  private templateStore = inject<Store<ITemplateState>>(Store);
  private authenticationStore = inject<Store<IAuthenticationState>>(Store);
  private _modalService = inject(NgbModal);
  private readonly sbModal = inject(SbModalService);
  private sanitizer = inject(DomSanitizer);
  private influencerService = inject(InfluencerService);
  private awsService = inject(AwsService);
  private campaignSharePresetService = inject(CampaignSharePresetService);
  private themeService = inject(ThemeService);
  private settingsService = inject(SettingsService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly textConditions = inject(SbTextConditionService);
  private readonly templateService = inject(TemplateService);

  public step;
  public campaign: any;
  public landingTemplate;
  public campaignMeta: any = {};
  public socialMedias: any = {};
  public settingChangedDebounceTimer: any;
  public sharePresets: any[] = [];
  public sharePresetOptions: any[] = [];
  public sharePresetPermissions: any = {};
  public selectedSharePresetId: number = null;
  public selectedSharePreset: any = null;
  public keepSharePresetSelectionOnNextSettingsChange = false;
  public sharePresetSaveMenuOpen = false;
  public sharePresetName = '';
  public sharePresetDescription = '';
  public sharePresetSubmitted = false;
  public sharePresetSections = {
    widget_ui_customization: true,
    meta_texts: true,
    share_image_design: true,
    custom_fields: true,
    custom_actions: true
  };
  public sharePresetApplySkips = {
    widget_ui_customization: false,
    meta_texts: false,
    share_image_design: false,
    custom_fields: false,
    custom_actions: false
  };
  public pendingSharePreset: any = null;
  private readonly sharePresetWidgetDefaults = {
    allow_influencers_to_edit_primary_info_use_global: true,
    allow_influencers_to_edit_primary_info: false,
    allow_influencers_to_update_their_picture_in_widget_use_global: true,
    allow_influencers_to_update_their_picture_in_widget: false,
    allow_influencers_to_update_their_video_in_widget_use_global: true,
    allow_influencers_to_update_their_video_in_widget: false,
    allow_influencers_to_use_ai_avatar_in_widget_use_global: true,
    allow_influencers_to_use_ai_avatar_in_widget: false,
    widget_ai_avatar_template: null,
    widget_profile_picture_min_width: 0,
    widget_profile_picture_min_height: 10,
    widget_profile_video_enable_recorder: true,
    widget_profile_video_min_duration: 0,
    widget_profile_video_max_duration: 10,
    widget_profile_video_min_width: 0,
    widget_profile_video_min_height: 0,
    widget_profile_video_target_aspect_width: 0,
    widget_profile_video_target_aspect_height: 0,
    widget_profile_video_caption_mode: 'let_user_decide',
    widget_profile_video_caption_let_user_decide: true,
    widget_profile_video_caption_position: 'bottom',
    widget_profile_video_caption_background_enabled: true,
    widget_profile_video_caption_background_color: '#FFFFFF',
    widget_profile_video_caption_background_opacity: 50,
    widget_profile_video_caption_font_color: '#000000',
    widget_profile_video_caption_font_opacity: 50,
    widget_profile_video_caption_font_family: '',
    widget_profile_video_caption_font_face: '',
    widget_profile_video_caption_font_url: '',
    widget_profile_video_background_mode: 'let_user_decide',
    widget_profile_video_background_let_user_decide: true,
    widget_profile_video_background_color: '#FFFFFF',
    widget_profile_video_enable_teleprompter: true,
    widget_profile_video_teleprompter_speed: 500,
    widget_profile_video_teleprompter_question: '',
    allow_campaign_to_launch_when_registration_widget_is_disabled: false,
    switch_widget_to_this_campaign_when_launched: false,
    public_widget_enabled: false,
    widget_language_use_global: false,
    widget_language: null,
    widget_header_1_use_global: false,
    widget_header_1: null,
    widget_header_2_use_global: false,
    widget_header_2: null,
    widget_header_3_use_global: false,
    widget_header_3: null,
    widget_open_message_text_use_global: false,
    widget_open_message_text: null,
    widget_promo_text_use_global: false,
    widget_promo_text: null
  };
  private readonly sharePresetWidgetKeys = Object.keys(this.sharePresetWidgetDefaults);
  // Use Global text keys: emptying these stores '' (an explicit blank), never null.
  // null means "the campaign never set this" and flips Use Global back on
  // (inheritUnsetCampaignWidgetFields()). action_buttons_no_action_message,
  // widget_language and widget_open_message_text are deliberately excluded and keep
  // storing null when emptied.
  private readonly useGlobalTextKeys = ['widget_header_1', 'widget_header_2', 'widget_header_3', 'widget_promo_text'];
  // Use Global only changes what the live widget and the preview render. These text fields always
  // show the campaign's own text (greyed while linked), and switching Use Global never writes them.
  private readonly campaignWidgetOwnTextKeys = [...this.useGlobalTextKeys, 'widget_open_message_text'];
  readonly widgetHeaderDescriptions = WIDGET_HEADER_DESCRIPTIONS;
  private readonly campaignWidgetOverrideSettings = [
    {
      key: 'allow_influencers_to_edit_primary_info',
      useGlobalKey: 'allow_influencers_to_edit_primary_info_use_global',
      globalKey: 'allow_influencers_to_edit_primary_info',
      valueType: 'boolean',
      defaultValue: false,
    },
    {
      key: 'allow_influencers_to_update_their_picture_in_widget',
      useGlobalKey: 'allow_influencers_to_update_their_picture_in_widget_use_global',
      globalKey: 'allow_influencers_to_update_their_picture_in_widget',
      valueType: 'boolean',
      defaultValue: false,
    },
    {
      key: 'allow_influencers_to_update_their_video_in_widget',
      useGlobalKey: 'allow_influencers_to_update_their_video_in_widget_use_global',
      globalKey: 'allow_influencers_to_update_their_video_in_widget',
      valueType: 'boolean',
      defaultValue: false,
    },
    {
      key: 'allow_influencers_to_use_ai_avatar_in_widget',
      useGlobalKey: 'allow_influencers_to_use_ai_avatar_in_widget_use_global',
      globalKey: 'allow_influencers_to_use_ai_avatar_in_widget',
      valueType: 'boolean',
      defaultValue: false,
    },
    {
      key: 'widget_language',
      useGlobalKey: 'widget_language_use_global',
      globalKey: 'language',
      valueType: 'value',
      defaultValue: null,
    },
    {
      key: 'widget_header_1',
      useGlobalKey: 'widget_header_1_use_global',
      globalKey: 'header_1',
      valueType: 'value',
      defaultValue: null,
    },
    {
      key: 'widget_header_2',
      useGlobalKey: 'widget_header_2_use_global',
      globalKey: 'header_2',
      valueType: 'value',
      defaultValue: null,
    },
    {
      key: 'widget_header_3',
      useGlobalKey: 'widget_header_3_use_global',
      globalKey: 'header_3',
      valueType: 'value',
      defaultValue: null,
    },
    {
      key: 'widget_open_message_text',
      useGlobalKey: 'widget_open_message_text_use_global',
      globalKey: 'open_message_text',
      valueType: 'value',
      defaultValue: null,
    },
    {
      key: 'widget_promo_text',
      useGlobalKey: 'widget_promo_text_use_global',
      globalKey: 'promo_text',
      valueType: 'value',
      defaultValue: null,
    },
  ];
  private readonly requiredGenericInfluencerFieldKeys = ['first_name', 'last_name', 'email'];
  public readonly imageCustomFieldLabelMaxLength = 14;
  public variables: any = {};
  public variablesFor = '';
  public isForMeta = false;
  public readonly influencerCampaignPageUrlVariable = '#InfluencerCampaignPageUrl#';
  public campaignPageUrlNotRenderedForSocialNetworks = ['instagram'];
  public readonly currentSocialSharePlatforms = ['facebook', 'twitter', 'linkedin', 'whatsapp', 'slack', 'instagram', 'email', 'facebook_messenger', 'microsoft_teams', 'sms', 'zalo', 'line', 'wechat', 'bluesky', 'telegram', 'vk', 'viber', 'signal', 'tiktok'];
  public readonly defaultShareMediaOrder = ['video', 'image'];
  public shareMediaOrder = [...this.defaultShareMediaOrder];

  public sectionsStatus = { campaign: true, content: true, widget: false, action_buttons: false, custom_fields: false };

  // Section currently torn out of the sidebar and shown in the expand popup.
  // While it is set the section renders collapsed and autosave is held.
  public expandedSectionKey: 'action_buttons' | 'custom_fields' | null = null;

  private expandedSectionBackup: any = null;

  private expandedSectionModalRef: NgbModalRef | null = null;

  private static readonly SECTION_META_KEYS = {
    action_buttons: ['action_buttons', 'action_buttons_required', 'action_buttons_no_action_message',
      'default_action_button_index'],
    custom_fields: ['influencer_fields'],
  };
  public socialMessageError = {
    facebook: false,
    twitter: false,
    linkedin: false,
    whatsapp: false,
    slack: false,
    instagram: false,
    email: false,
    facebook_messenger: false,
    microsoft_teams: false,
    sms: false,
    zalo: false,
    line: false,
    wechat: false,
    bluesky: false,
    telegram: false,
    vk: false,
    viber: false,
    signal: false,
    tiktok: false,
  };
  public socialPlatformVisibility = {
    facebook: true,
    bluesky: true,
    twitter: true,
    linkedin: true,
    whatsapp: true,
    slack: true,
    instagram: true,
    email: true,
    facebook_messenger: true,
    microsoft_teams: true,
    sms: true,
    zalo: false,
    line: false,
    wechat: false,
    telegram: false,
    vk: false,
    viber: false,
    signal: false,
    tiktok: false,
  };
  public currentSocialMediaPreviewing = 'linkedin';
  private previewTheme: 'light' | 'dark' = 'light';
  private rawPreviewUrl: string | null = null;
  boxWidth = 30;
  boxHeight = 30;
  private readonly socialNetworkGridItemSize = 36;
  private readonly socialNetworksIconsVerticalPadding = 12;
  columns = 10;
  positions = [
    { id: 'linkedin', x: 10, y: 0, active: true, order: 0 },
    { id: 'whatsapp', x: 40, y: 0, active: true, order: 1 },
    { id: 'email', x: 70, y: 0, active: true, order: 2 },
    { id: 'facebook', x: 100, y: 0, active: true, order: 3 },
    { id: 'instagram', x: 130, y: 0, active: true, order: 4 },
    { id: 'sms', x: 160, y: 0, active: true, order: 5 },
    { id: 'facebook_messenger', x: 190, y: 0, active: true, order: 6 },
    { id: 'twitter', x: 220, y: 0, active: true, order: 7 },
    { id: 'microsoft_teams', x: 250, y: 0, active: true, order: 8 },
    { id: 'slack', x: 280, y: 0, active: true, order: 9 },
    { id: 'bluesky', x: 10, y: 30, active: true, order: 10 },
    { id: 'zalo', x: 40, y: 30, active: false, order: 11 },
    { id: 'line', x: 70, y: 30, active: false, order: 12 },
    { id: 'wechat', x: 100, y: 30, active: false, order: 13 },
    { id: 'telegram', x: 130, y: 30, active: false, order: 14 },
    { id: 'vk', x: 160, y: 30, active: false, order: 15 },
    { id: 'viber', x: 190, y: 30, active: false, order: 16 },
    { id: 'signal', x: 220, y: 30, active: false, order: 17 },
    { id: 'tiktok', x: 250, y: 30, active: false, order: 18 },
  ];
  private platformLimits: { [key: string]: number } = {
    twitter: 280,
    sms: 160,
    // linkedin: 3000 // Add other platforms as needed
  };
  readonly metaDescriptionMaxLength = 160;
  /** The condition spec and variables for conditional text, once loaded (null until then or without them). */
  textConditionContext: TextConditionContext | null = null;
  readonly videoUploadPolicy = {
    format: 'mp4',
    maxSizeBytes: 300 * 1024 * 1024,
    minWidth: 600,
    minHeight: 315,
    maxWidth: 1920,
    maxHeight: 1920,
    minAspectRatio: 0.56,
    maxAspectRatio: 1.91,
    minDurationSeconds: 3,
    maxDurationSeconds: 60,
    minFrameRate: 10,
    maxFrameRate: 30,
    codecDescription: 'H.264 video with AAC audio'
  };
  loader$: Observable<boolean>;
  currentUser: any;
  unsubscriber = new Subject();
  subscription: any;
  previewClicked = false;
  previewGenericClicked = false;
  previewUrl = null;
  // Why there is no preview to show (a campaign with no contact yet), as the server says it.
  previewUnavailableMessage: string = null;
  videoRecorderPageMode = false;
  uploadTab = 'image';
  videoURL = '';
  videoWidth = '';
  videoHeight = '';
  videoPreviewUrl = '';
  videoPosterPreviewUrl = '';
  // Preview Media: what each container last finished loading, keyed by URL, so a new preview -
  // regenerated, uploaded, or the other source - starts out loading again by itself.
  previewMediaLoad: {[kind: string]: {src: string; state: 'loaded' | 'error'}} = {};
  // Each preview video's own aspect ratio, by URL, once its metadata has loaded.
  previewVideoShapes: {[src: string]: string} = {};
  // How long a Preview Image/Video render is waited on with a spinner before saying it is late.
  readonly previewGenerationTimeoutMs = 3 * 60 * 1000;
  private previewGenerationTimers = new Map<string, any>();
  private previewGenerationTimedOut = new Set<string>();
  // Personalize Video is copying the image design into the video design and saving; the buttons
  // that would start or undo it wait for it.
  videoTemplateRequestPending = false;
  // Set once the page is left: a request that finishes after that goes nowhere.
  private pageLeft = false;
  contentType = '';
  isVideoUploaded = false;
  validatedVideoInfo = null;
  videoUploadEnabled = false;
  uploadMediaType = 'image';
  contentFile = null;
  contentSignedUrl = null;
  pendingMediaUploads: any = {
    image: null,
    video: null,
    video_poster: null
  };
  pendingActionVideoUploads = new Map<any, File>();
  fileUploadProgress = 0;
  socialShareInfo = false;
  alreadyVisitedTabs: string[] = [this.currentSocialMediaPreviewing];
  socialShareSkip = '';
  widgetAIAvatarTemplates = [];
  selectedWidgetAIAvatarTemplate = null;

  // Save queue: every save (autosave, explicit Save, uploads) is chained on this promise so
  // only one PUT is ever in flight and later values always win. changeSeq/savedSeq back
  // hasUnsavedChanges() for the leave guard and the beforeunload handler.
  private saveQueue: Promise<'saved' | 'invalid' | 'failed'> = Promise.resolve('saved');
  private changeSeq = 0;
  private savedSeq = 0;

  campaigns: any = [];
  influencerTypes: InfluencerType[] = [];
  filteredInfluencerTypes: InfluencerType[] = [];
  segmentsGlobal: any = [];

  defaultPanelWidth = 700;
  panelWidth = this.defaultPanelWidth;
  panelCollapsed = false;

  // Influencer navigation for widget preview
  previewInfluencers: any[] = [];
  currentInfluencerIndex = 0;
  isGenericPreview = false;

  private readonly aspectRatio: number = null;
  private readonly portrait: number | boolean = false;
  private readonly landscape: number | boolean = false;
  private readonly videoRecorderPageModeMessageHandler = (event: MessageEvent) => {
    const data = event?.data;
    if (!data || typeof data !== 'object') {
      return;
    }

    if (data.name === 'snoballVideoRecorderPageMode') {
      this.setVideoRecorderPageMode(Boolean(data.active));
      this.cdr.markForCheck();
    }
  };

  readonly title = viewChild<ElementRef>('title');
  readonly message = viewChild<ElementRef>('message');
  readonly description = viewChild<ElementRef>('description');
  readonly widgetPreviewIframe = viewChild.required<ElementRef<HTMLIFrameElement>>('widgetPreviewIframe');
  readonly imageButtonsDiv = viewChild<ElementRef>('imageButtonsDiv');
  public widget_Settings;

  // Use Global text keys store '' for a deliberately emptied field; everything else
  // (action_buttons_no_action_message, etc.) keeps storing null when emptied.
  private normalizeCampaignWidgetTextValue(key: string, value: any) {
    return this.useGlobalTextKeys.includes(key) ? (value || '') : (value || null);
  }

  onWidgetTextEditorChange(key, value, editorComponent = null) {
    if (this.isCampaignWidgetUsingGlobal(key)) {
      return;
    }
    this.syncTextEditorDataCache(null, key, value);
    const normalizedValue = this.getCustomFieldEditorOutputValue(value, editorComponent);
    this.campaignMeta[key] = this.normalizeCampaignWidgetTextValue(key, normalizedValue);
    this.onSettingsChange(normalizedValue);
  }

  private getEditorModeFromPlainTextState(isPlainTextMode) {
    return isPlainTextMode
      ? this.richTextEditorModePlainText
      : this.richTextEditorModeFormatting;
  }

  private getActionValueEditorMode(action) {
    return action?.valueEditorMode || this.richTextEditorModeFormatting;
  }

  private setActionValueEditorMode(action, mode) {
    action.valueEditorMode = mode || this.richTextEditorModeFormatting;
  }

  private getWidgetTextEditorModes() {
    if (!this.campaignMeta.widget_text_editor_modes ||
      typeof this.campaignMeta.widget_text_editor_modes !== 'object' ||
      Array.isArray(this.campaignMeta.widget_text_editor_modes)) {
      this.campaignMeta.widget_text_editor_modes = {};
    }

    return this.campaignMeta.widget_text_editor_modes;
  }

  private setWidgetTextEditorMode(key, mode) {
    this.getWidgetTextEditorModes()[key] = mode || this.richTextEditorModeFormatting;
  }

  private isWidgetHeaderTextEditorKey(key) {
    return ['widget_header_1', 'widget_header_2', 'widget_header_3'].includes(key);
  }

  private isWidgetHeaderSettingKey(key) {
    return ['header_1', 'header_2', 'header_3'].includes(key);
  }

  private isWidgetTextEditorMultilineKey(key) {
    return [
      'widget_promo_text',
      'promo_text',
      'action_buttons_no_action_message'
    ].includes(key);
  }

  private decodeEditorTextEntities(value) {
    const text = String(value || '');
    if (!text.includes('&') || typeof document === 'undefined') {
      return text.replace(/\u00a0/g, ' ');
    }

    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value.replace(/\u00a0/g, ' ');
  }

  private htmlToEditorPlainText(value, multiline) {
    const text = this.decodeEditorTextEntities(
      String(value || '')
        .replace(/\r\n?/g, '\n')
        .replace(/>\s*\n\s*</g, '><')
        .replace(/<br\s*\/?>[ \t]*\n[ \t]*/gi, '<br />')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(p|div)>/gi, '\n')
        .replace(/<[^>]*>/g, '')
    );

    return multiline
      ? text
      : text.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim();
  }

  private plainTextToEditorData(value, multiline) {
    const plainText = multiline
      ? String(value || '')
      : String(value || '').replace(/[\r\n]+/g, ' ');

    return this.escapeEditorText(plainText).replace(/\r\n?|\n/g, '<br />');
  }

  private getCachedTextEditorData(cacheOwner = null, cacheKey = null) {
    if (cacheOwner && typeof cacheOwner === 'object') {
      return this.objectTextEditorDataCache.get(cacheOwner) || null;
    }

    return cacheKey ? this.widgetTextEditorDataCache[cacheKey] || null : null;
  }

  private setCachedTextEditorData(cacheOwner = null, cacheKey = null, value = '') {
    if (cacheOwner && typeof cacheOwner === 'object') {
      this.objectTextEditorDataCache.set(cacheOwner, value);
      return;
    }

    if (cacheKey) {
      this.widgetTextEditorDataCache[cacheKey] = value;
    }
  }

  private clearCachedTextEditorData(cacheOwner = null, cacheKey = null) {
    if (cacheOwner && typeof cacheOwner === 'object') {
      this.objectTextEditorDataCache.delete(cacheOwner);
      return;
    }

    if (cacheKey) {
      delete this.widgetTextEditorDataCache[cacheKey];
    }
  }

  private isEditorComponentInPlainTextMode(editorComponent: SbRichTextComponent | null = null) {
    return !!editorComponent?.plainText();
  }

  private isEditorComponentMultiline(editorComponent: SbRichTextComponent | null = null) {
    return !!editorComponent?.multiline();
  }

  private syncTextEditorDataCache(
    cacheOwner,
    cacheKey,
    value
  ) {
    this.setCachedTextEditorData(cacheOwner, cacheKey, value);
  }

  getCustomFieldEditorConfig(field) {
    return this.customFieldDefaultValueEditorConfig;
  }

  getActionCustomFieldEditorConfig(customFieldKey, action = null) {
    return this.customFieldDefaultValueEditorConfig;
  }

  getWidgetTextEditorConfig(key) {
    if (key === 'action_buttons_no_action_message') {
      return this.noActionMessageEditorConfig;
    }

    const config = this.isWidgetHeaderTextEditorKey(key)
      ? this.widgetHeaderTextEditorConfig
      : this.widgetTextEditorConfig;

    return config;
  }

  getActionWidgetSettingEditorConfig(settingKey, _action = null) {
    const config = this.isWidgetHeaderSettingKey(settingKey)
      ? this.widgetHeaderTextEditorConfig
      : this.widgetTextEditorConfig;

    return config;
  }

  private getTextEditorData(
    value,
    multiline,
    plainTextMode = false,
    cacheOwner = null,
    cacheKey = null
  ) {
    const data = value || '';
    const cachedData = this.getCachedTextEditorData(cacheOwner, cacheKey);
    if (plainTextMode) {
      const plainText = this.htmlToEditorPlainText(data, multiline);
      if (cachedData !== null &&
        this.htmlToEditorPlainText(cachedData, multiline) === plainText) {
        return cachedData;
      }

      const editorData = this.plainTextToEditorData(plainText, multiline);
      this.setCachedTextEditorData(cacheOwner, cacheKey, editorData);
      return editorData;
    }

    if (cachedData !== null && this.ensureEditorLinksOpenInNewTab(cachedData) === data) {
      return cachedData;
    }

    this.clearCachedTextEditorData(cacheOwner, cacheKey);

    const editorData = this.convertBreakTagsToEditorSpans(data);
    if (!multiline || this.hasHtmlTags(editorData)) {
      return editorData;
    }

    return this.convertBreakTagsToEditorSpans(
      this.escapeEditorText(editorData).replace(/\r\n?|\n/g, '<br />')
    );
  }

  getCustomFieldEditorData(value, field) {
    return this.getTextEditorData(
      value,
      true,
      false,
      field
    );
  }

  getActionCustomFieldEditorData(customFieldKey, value, action = null) {
    return this.getTextEditorData(
      value,
      true,
      false,
      action
    );
  }

  getWidgetTextEditorData(key) {
    return this.getTextEditorData(
      this.getCampaignWidgetFieldValue(key) || '',
      this.isWidgetTextEditorMultilineKey(key),
      false,
      null,
      key
    );
  }

  getActionWidgetSettingEditorData(settingKey, value, _action = null) {
    return this.getTextEditorData(
      value || '',
      this.isWidgetTextEditorMultilineKey(settingKey),
      false,
      _action
    );
  }

  private escapeEditorText(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  private hasHtmlTags(value) {
    return /<\/?[a-z][\s\S]*>/i.test(String(value || ''));
  }

  private ensureEditorLinksOpenInNewTab(value) {
    if (!value || typeof document === 'undefined') {
      return value || '';
    }

    const container = document.createElement('div');
    container.innerHTML = value;
    this.unwrapEditorBlockWrappers(container);
    this.normalizeEditorInlineStyles(container);
    this.convertContainerBreakTagsToEditorSpans(container);
    container.querySelectorAll<HTMLAnchorElement>('a[href]').forEach((link) => {
      if (!link.getAttribute('target')) {
        link.setAttribute('target', '_blank');
      }
      if (!link.getAttribute('rel')) {
        link.setAttribute('rel', 'noopener noreferrer');
      }
      if (!link.style.textDecoration) {
        link.style.textDecoration = 'underline';
      }
    });
    return container.innerHTML;
  }

  private convertBreakTagsToEditorSpans(value) {
    const html = String(value || '');
    if (!/<br\s*\/?>/i.test(html) || typeof document === 'undefined') {
      return html;
    }

    const container = document.createElement('div');
    container.innerHTML = html;
    this.unwrapEditorBlockWrappers(container);
    this.normalizeEditorInlineStyles(container);
    this.convertContainerBreakTagsToEditorSpans(container);
    return container.innerHTML;
  }

  private convertContainerBreakTagsToEditorSpans(container: HTMLElement) {
    if (!container.querySelector('br')) {
      return;
    }

    const lines = this.splitNodesByBreaks(Array.from(container.childNodes));
    const fragment = document.createDocumentFragment();
    lines.forEach((line) => {
      // A break inside a saved line splits that line's block span too, leaving empty copies
      // of it behind. Kept, they gave a blank line no height, so it vanished in the widget.
      Array.from(line.childNodes).forEach((child) => {
        if (child.nodeType === Node.ELEMENT_NODE && !child.textContent
          && !this.hasEditorMedia(child as HTMLElement)) {
          child.remove();
        }
      });

      const lineWrapper = document.createElement('span');
      lineWrapper.style.display = 'block';
      if (!/\S/.test(line.textContent || '') && !this.hasEditorMedia(line)) {
        lineWrapper.innerHTML = '&nbsp;';
        fragment.appendChild(lineWrapper);
        return;
      }

      // A line that already is one block span stays that span, rather than gaining another
      // level of nesting on every save.
      const only = line.childNodes.length === 1 ? line.firstChild as HTMLElement : null;
      if (this.isEditorBlockSpan(only)) {
        fragment.appendChild(this.flattenEditorBlockSpans(only));
        return;
      }

      while (line.firstChild) {
        lineWrapper.appendChild(line.firstChild);
      }
      fragment.appendChild(lineWrapper);
    });

    container.innerHTML = '';
    container.appendChild(fragment);
  }

  private hasEditorMedia(node: HTMLElement | DocumentFragment): boolean {
    const media = 'img,video,iframe,svg,hr';
    return (node instanceof HTMLElement && node.matches(media)) || !!node.querySelector(media);
  }

  private isEditorBlockSpan(node: Node | null): node is HTMLElement {
    return node?.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === 'SPAN'
      && (node as HTMLElement).style.display === 'block';
  }

  /** Whether a block span carries nothing but display: block, so it can give way to its child. */
  private isPlainEditorBlockSpan(span: HTMLElement): boolean {
    return span.attributes.length === 1 && span.style.length === 1;
  }

  /** Collapses block spans nested one in another, as earlier saves left them, into one. */
  private flattenEditorBlockSpans(span: HTMLElement): HTMLElement {
    let current = span;
    while (current.childNodes.length === 1 && this.isEditorBlockSpan(current.firstChild)) {
      const inner = current.firstChild as HTMLElement;
      if (this.isPlainEditorBlockSpan(current)) {
        current = inner;
      } else if (this.isPlainEditorBlockSpan(inner)) {
        inner.replaceWith(...Array.from(inner.childNodes));
      } else {
        break;
      }
    }
    return current;
  }

  private splitNodesByBreaks(nodes: Node[]) {
    const lines = [document.createDocumentFragment()];
    // A saved line is a block span, so it is a line of its own even with no break in it.
    let afterBlock = false;
    nodes.forEach((node) => {
      const block = this.isEditorBlockSpan(node);
      if (afterBlock && !block && node.nodeType === Node.TEXT_NODE && !/\S/.test(node.textContent || '')) {
        return;
      }
      if ((block || afterBlock) && lines[lines.length - 1].childNodes.length) {
        lines.push(document.createDocumentFragment());
      }
      afterBlock = block;
      const nodeLines = this.splitNodeByBreaks(node);
      const firstLine = nodeLines.shift();
      if (firstLine) {
        while (firstLine.firstChild) {
          lines[lines.length - 1].appendChild(firstLine.firstChild);
        }
      }
      nodeLines.forEach((line) => {
        lines.push(line);
      });
    });

    return lines;
  }

  private splitNodeByBreaks(node: Node) {
    if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === 'BR') {
      return [
        document.createDocumentFragment(),
        document.createDocumentFragment()
      ];
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      const fragment = document.createDocumentFragment();
      fragment.appendChild(node.cloneNode(true));
      return [fragment];
    }

    const element = node as HTMLElement;
    const childLines = this.splitNodesByBreaks(Array.from(element.childNodes));
    // A block ends its last line itself: a break at its very end adds no line in the browser.
    if (this.isEditorBlockSpan(element) && childLines.length > 1
      && !childLines[childLines.length - 1].childNodes.length) {
      childLines.pop();
    }
    return childLines.map((line) => {
      const elementClone = element.cloneNode(false) as HTMLElement;
      const fragment = document.createDocumentFragment();
      while (line.firstChild) {
        elementClone.appendChild(line.firstChild);
      }
      fragment.appendChild(elementClone);
      return fragment;
    });
  }

  private normalizeEditorInlineStyles(container: HTMLElement) {
    this.replaceEditorInlineStyleTags(container, 'strong,b', { 'font-weight': 'bold' });
    this.replaceEditorInlineStyleTags(container, 'em,i', { 'font-style': 'italic' });
    this.replaceEditorInlineStyleTags(container, 'u', { 'text-decoration': 'underline' });
  }

  private replaceEditorInlineStyleTags(
    container: HTMLElement,
    selector: string,
    styles: { [key: string]: string }
  ) {
    Array.from(container.querySelectorAll<HTMLElement>(selector)).forEach((element) => {
      const span = document.createElement('span');
      Array.from(element.attributes).forEach((attribute) => {
        span.setAttribute(attribute.name, attribute.value);
      });
      Object.entries(styles).forEach(([key, value]) => {
        span.style.setProperty(key, value);
      });

      while (element.firstChild) {
        span.appendChild(element.firstChild);
      }
      element.replaceWith(span);
    });
  }

  private unwrapEditorBlockWrappers(container: HTMLElement) {
    const blockTags = ['DIV', 'P'];
    const nodes = Array.from(container.childNodes);
    if (!nodes.some((node) => node.nodeType === Node.ELEMENT_NODE &&
      blockTags.includes((node as HTMLElement).tagName))) {
      return;
    }

    const fragment = document.createDocumentFragment();
    nodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE ||
        !blockTags.includes((node as HTMLElement).tagName)) {
        fragment.appendChild(node);
        return;
      }

      if (fragment.childNodes.length) {
        fragment.appendChild(document.createElement('br'));
      }

      const element = node as HTMLElement;
      if (!element.childNodes.length || element.innerHTML === '<br>') {
        return;
      }

      if (element.style.textAlign) {
        const alignedContent = document.createElement('span');
        alignedContent.style.display = 'block';
        alignedContent.style.textAlign = element.style.textAlign;
        while (element.firstChild) {
          alignedContent.appendChild(element.firstChild);
        }
        fragment.appendChild(alignedContent);
        return;
      }

      while (element.firstChild) {
        fragment.appendChild(element.firstChild);
      }
    });

    container.innerHTML = '';
    container.appendChild(fragment);
  }

  private getCustomFieldEditorOutputValue(value, editorComponent = null) {
    if (!this.isEditorComponentInPlainTextMode(editorComponent)) {
      return this.ensureEditorLinksOpenInNewTab(value);
    }

    const plainText = this.htmlToEditorPlainText(
      value,
      this.isEditorComponentMultiline(editorComponent)
    );

    return this.isEditorComponentMultiline(editorComponent)
      ? plainText
      : plainText.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim();
  }

  onCustomFieldDefaultValueEditorChange(field, value, editorComponent = null) {
    this.syncTextEditorDataCache(field, null, value);
    field.defaultValue = this.getCustomFieldEditorOutputValue(value, editorComponent);
    this.onSettingsChange(field.defaultValue);
  }

  onActionRichTextEditorChange(action, value, editorComponent = null) {
    this.syncTextEditorDataCache(action, null, value);
    const normalizedValue = this.getCustomFieldEditorOutputValue(value, editorComponent);
    action.value = normalizedValue || null;
    this.onSettingsChange(normalizedValue);
  }

  isRichTextWidgetSettingKey(settingKey: string): boolean {
    return ['header_1', 'header_2', 'header_3', 'promo_text'].includes(settingKey);
  }

  onWidgetTextEditorVariableClick(variable, key, editor: SbRichTextComponent | null = null) {
    if (this.isCampaignWidgetUsingGlobal(key)) {
      return;
    }
    if (!this.campaignMeta[key]) {
      this.campaignMeta[key] = '';
    }

    if (editor) {
      editor.insertText(variable.key);
      const editorData = editor.currentHtml();
      this.syncTextEditorDataCache(null, key, editorData);
      this.campaignMeta[key] = this.normalizeCampaignWidgetTextValue(key, this.getCustomFieldEditorOutputValue(editorData, editor));
    } else {
      this.campaignMeta[key] = `${this.campaignMeta[key]}${variable.key}`;
    }

    this.variablesFor = '';
    this.onSettingsChange(null, 2, false);
  }

  registerActionRichTextEditor(action, editorComponent) {
    if (action && editorComponent) {
      this.actionRichTextEditors.set(action, editorComponent);
    }
  }

  onActionRichTextVariableClick(variable, action) {
    const editorComponent = this.actionRichTextEditors.get(action);
    if (editorComponent) {
      editorComponent.insertText(variable.key);
      const editorData = editorComponent.currentHtml();
      this.syncTextEditorDataCache(action, null, editorData);
      action.value = this.getCustomFieldEditorOutputValue(editorData, editorComponent) || null;
    } else {
      action.value = `${action.value || ''}${variable.key}`;
    }

    this.onSettingsChange(null, 2, false);
  }

  onActionButtonsActiveChange(active: boolean): void {
    const next = !!active;
    this.campaignMeta['action_buttons_active'] = next;
    this.sectionsStatus['action_buttons'] = next;
    this.onSettingsChange(next);
  }

  onInfluencerFieldsActiveChange(active: boolean): void {
    const next = !!active;
    this.campaignMeta['influencer_fields_active'] = next;
    this.sectionsStatus['custom_fields'] = next;
    this.onSettingsChange(next);
  }

  // Visual-only expanded state. Deliberately separate from the on/off flag the header
  // switch writes, so opening the popup never disables the feature or triggers a save.
  isSectionExpanded(key: 'action_buttons' | 'custom_fields'): boolean {
    const flag = key === 'action_buttons' ? 'action_buttons_active' : 'influencer_fields_active';
    return !!this.campaignMeta[flag] && this.expandedSectionKey !== key;
  }

  openSectionInModal(key: 'action_buttons' | 'custom_fields', template: any): void {
    if (this.expandedSectionKey) {
      return;
    }

    // Flush whatever the autosave debounce already queued, so the snapshot below matches
    // what is persisted and no stale save fires once the popup is open. onSave() cancels
    // the debounce itself.
    if (this.settingChangedDebounceTimer) {
      this.onSave();
    }

    this.expandedSectionBackup = this.snapshotSectionMeta(ShareCampaignComponent.SECTION_META_KEYS[key]);
    this.expandedSectionKey = key;

    this.expandedSectionModalRef = this._modalService.open(template, {
      size: 'xl',
      centered: false,
      scrollable: true,
      keyboard: true,
      backdrop: 'static',
      windowClass: 'section-expand-modal'
    });

    this.expandedSectionModalRef.result.then(
      () => this.finishExpandedSection(false),
      () => this.finishExpandedSection(true)
    );
  }

  saveExpandedSection(modal: any): void {
    // Edits are already on campaignMeta; finishExpandedSection() commits them.
    modal.close('saved');
  }

  private finishExpandedSection(discard: boolean): void {
    const key = this.expandedSectionKey;
    const backup = this.expandedSectionBackup;

    this.expandedSectionKey = null;
    this.expandedSectionBackup = null;
    this.expandedSectionModalRef = null;
    this.cdr.markForCheck();

    if (!key) {
      return;
    }

    if (discard) {
      this.restoreSectionMeta(backup);
      if (key === 'action_buttons') {
        // Map keys are action object references that the rollback just replaced.
        this.pendingActionVideoUploads.clear();
      }
      return;
    }

    this.onSettingsChange(null);
  }

  // _.pick would drop keys that are not set yet, and those must come back as unset
  // rather than keeping whatever the popup wrote, so presence is recorded explicitly.
  private snapshotSectionMeta(keys: string[]): {keys: string[]; values: any; present: string[]} {
    const values = {};
    const present = [];

    for (const key of keys) {
      if (Object.prototype.hasOwnProperty.call(this.campaignMeta, key)) {
        present.push(key);
      }
      values[key] = _.cloneDeep(this.campaignMeta[key]);
    }

    return {keys, values, present};
  }

  private restoreSectionMeta(backup: {keys: string[]; values: any; present: string[]}): void {
    if (!backup) {
      return;
    }

    for (const key of backup.keys) {
      if (backup.present.indexOf(key) === -1) {
        delete this.campaignMeta[key];
      } else {
        this.campaignMeta[key] = _.cloneDeep(backup.values[key]);
      }
    }
  }

  get socialNetworksIconsHeight(): number {
    const iconsBottom = Math.max(
      ...this.positions.map(position => position.y + this.socialNetworkGridItemSize)
    );

    return Math.max(50, iconsBottom + this.socialNetworksIconsVerticalPadding);
  }

  private bindPreviewIframeClickHandler(iframeDocument: Document): void {
    if (this.previewIframeDocument === iframeDocument) {
      return;
    }

    this.removePreviewIframeClickHandler();
    this.previewIframeDocument = iframeDocument;
    this.previewIframeDocument.addEventListener('click', this.previewIframeClickHandler, true);
  }

  private removePreviewIframeClickHandler(): void {
    if (!this.previewIframeDocument) {
      return;
    }

    this.previewIframeDocument.removeEventListener('click', this.previewIframeClickHandler, true);
    this.previewIframeDocument = null;
  }

  private closeCustomFieldDefaultValuePopovers(): void {
    this.customFieldDefaultValuePopovers().forEach((popover) => popover.close());
    this.actionRichTextValuePopovers()?.forEach((popover) => popover.close());
  }

  getDefaultCustomFieldColor() {
    return null;
  }

  isValidCustomFieldColor(value) {
    if (!value || typeof value !== 'string') {
      return false;
    }

    const color = value.trim();
    return /^#[0-9a-fA-F]{3,8}$/.test(color)
      || /^rgba?\(\s*(\d{1,3}%?\s*,\s*){2}\d{1,3}%?(\s*,\s*(0|1|0?\.\d+|\d+%))?\s*\)$/.test(color)
      || /^hsla?\(\s*-?\d+(deg|rad|turn)?\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%(\s*,\s*(0|1|0?\.\d+|\d+%))?\s*\)$/.test(color)
      || /^(transparent|currentColor)$/i.test(color);
  }

  normalizeCustomFieldDefaultValue(field) {
    if (field.field_type !== 'custom' || field.type !== 'color') {
      return field.defaultValue;
    }

    return this.isValidCustomFieldColor(field.defaultValue)
      ? field.defaultValue.trim()
      : null;
  }

  onCustomFieldColorDefaultValueChange(field, value) {
    field.defaultValue = this.normalizeCustomFieldDefaultValue({
      ...field,
      defaultValue: value
    });
    this.onSettingsChange(field.defaultValue);
  }

  private readonly richTextEditorModeFormatting = 'formatting';

  private readonly richTextEditorModePlainText = 'plain_text';

  public readonly customFieldDefaultValueEditorConfig: WidgetTextEditorConfig = {
    ...WIDGET_TEXT_EDITOR_CONFIG,
    height: 130,
  };

  public readonly widgetTextEditorConfig = WIDGET_TEXT_EDITOR_CONFIG;

  public readonly noActionMessageEditorConfig: WidgetTextEditorConfig = {
    ...WIDGET_TEXT_EDITOR_CONFIG,
    tools: toolsFromToolbarGroups([
      {items: ['Undo', 'Redo']},
      {items: ['Bold', 'Italic', 'Underline']},
      {items: ['FontSize']},
      {items: ['TextColor']},
      {items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight']},
      {items: ['Link']},
    ]),
  };

  public readonly widgetHeaderTextEditorConfig = WIDGET_HEADER_TEXT_EDITOR_CONFIG;

  private readonly objectTextEditorDataCache = new WeakMap<object, string>();

  private readonly actionRichTextEditors = new WeakMap<object, SbRichTextComponent>();

  private readonly widgetTextEditorDataCache = {};

  readonly customFieldDefaultValuePopovers = viewChildren<NgbPopover>('customFieldDefaultValuePopover');

  readonly actionRichTextValuePopovers = viewChildren<NgbPopover>('actionRichTextValuePopover');

  private readonly previewIframeClickHandler = () => {
    this.closeCustomFieldDefaultValuePopovers();
    this.cdr.markForCheck();
  };

  private previewIframeDocument: Document = null;

  constructor() {
    this.previewTheme = this.resolvePreviewTheme();
    this.setDefault();
    this.fileUploadStore.dispatch(ResetFileState({ params: { error: '', file: null } }));
    this.authenticationStore.pipe(select(getToken), takeUntil(this.unsubscriber)).subscribe(newToken => {
      if (newToken) {
        this.token = newToken;
        this.cdr.markForCheck();
      }
    });
    this.subscribeStore();
    this.subscription = this.socketService.sourceData
      .subscribe((message: any) => {
        if (message?.data?.requesterId) {
          if (message.data?.requesterType === 'template') {
            if (this.campaign?.social_video_template?.id === message?.data?.requesterId) {
              this.campaign = _.cloneDeep(this.campaign);
              this.campaign.social_video_template.thumbnail = message.data.result.thumbnail;
              this.campaign.social_video_template.thumbnail_content_hash = this.campaign.social_video_template.content_hash;
            } else if (this.campaign) {
              this.campaign = _.cloneDeep(this.campaign);
              if (!this.campaign.social_template) {
                this.campaign.social_template = {};
              }
              if (this.campaign.social_template?.id === message?.data?.requesterId) {
                this.campaign.social_template.thumbnail = message.data.result.thumbnail;
                this.campaign.social_template.thumbnail_content_hash = this.campaign.social_template.content_hash;
              }
            }
          }
          // The Preview Video is its own message, so it never lands on the thumbnail. Only the
          // video design has one.
          if (message.data?.requesterType === 'template_share_video') {
            if (this.campaign?.social_video_template?.id === message?.data?.requesterId) {
              this.campaign = _.cloneDeep(this.campaign);
              const template = this.campaign.social_video_template;
              template.share_video = message.data.result.thumbnail || null;
              template.share_video_content_hash = template.content_hash;
              // A still of the design, when the template has nowhere to play a clip: shown with it.
              template.share_video_warning = message.data.result.warning || null;
              this.resetPreviewGeneration('video');
            }
          }
          this.cdr.markForCheck();
        }
      },
      (err) => console.error(err),
      () => console.warn('Completed!')
      );
  }

  subscribeStore() {
    this.authenticationStore.pipe(select(getLoggedInUser))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(user => {
        this.currentUser = user;
        this.cdr.markForCheck();
      });

    this.fileUploadStore.pipe(select(getSignedUrlError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });
    this.fileUploadStore.pipe(select(getUploadToSignedUrlError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });
    this.fileUploadStore.pipe(select(getFileUploadProgress))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((data: any) => {
        if (data !== undefined && data !== null) {
          this.fileUploadProgress = data;
          this.cdr.markForCheck();
        }
      });
    this.fileUploadStore.pipe(select(getSignedUrl))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((data: any) => {
        if (data && data.url) {
          this.contentSignedUrl = data.url;
          this.cdr.markForCheck();
        }
      });
    this.fileUploadStore.pipe(select(getUploadToSignedUrl))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((data: any) => {
        if (data && this.contentSignedUrl) {
          const pathUrl = this.contentSignedUrl.split('?')[0];
          this.campaignMeta = {
            ...this.campaignMeta,
            ...(this.uploadMediaType === 'video' ? {
              video: pathUrl,
              video_validation: null
            } : this.uploadMediaType === 'video_poster' ? {
              video_poster: pathUrl
            } : {
              image: pathUrl,
              image_template: this.keepsTemplateForUploadedImage()
            }),
          };
          if (this.uploadMediaType === 'video') {
            this.videoPreviewUrl = '';
          }
          if (this.uploadMediaType === 'video_poster') {
            this.videoPosterPreviewUrl = '';
          }
          this.isVideoUploaded = false;
          this.uploadMediaType = 'image';
          this.contentSignedUrl = null;
          this.contentFile = null;
          this.enqueueSave();
          this.cdr.markForCheck();
        }
      });

    this.templateStore.pipe(select(getWidgetAvatarTemplates))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(widgetAvatarTemplates => {
        if (widgetAvatarTemplates && widgetAvatarTemplates.length > 0) {
          this.widgetAIAvatarTemplates = widgetAvatarTemplates.map((item) => ({
            ...item,
            selectedImageVariation: item?.image_variations?.find(image => image.isActive)
          }));
          this.selectedWidgetAIAvatarTemplate = (this.campaignMeta.hasOwnProperty('widget_ai_avatar_template') && this.campaignMeta['widget_ai_avatar_template']) ?
            this.widgetAIAvatarTemplates.find(item => item.id === this.campaignMeta['widget_ai_avatar_template']) : null;
          this.cdr.markForCheck();
        }
      });

    this.campaignStore.pipe(select(getCampaignWidgetPreviewUrl))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(widgetPreviewUrl => {
        if (widgetPreviewUrl?.url) {
          this.setPreviewUrl(widgetPreviewUrl.url);
        } else if (widgetPreviewUrl) {
          this.rawPreviewUrl = null;
          this.previewUrl = null;
          this.previewUnavailableMessage = widgetPreviewUrl.message || null;
        }
        this.cdr.markForCheck();
      });

    this.campaignStore.pipe(select(getPaginatedCampaigns))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(paginatedCampaigns => {
        if (paginatedCampaigns && this.campaign) {
          this.campaigns = paginatedCampaigns.list;
          this.cdr.markForCheck();
        }
      }
      );

    this.influencerStore.pipe(select(getInfluencersTypes))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencerTypes => {
        if (influencerTypes && influencerTypes.length > 0 && this.campaign) {
          this.influencerTypes = influencerTypes;

          const segment = this.getCampaignSegment();
          if (segment) {
            this.filteredInfluencerTypes = this.influencerTypes.filter(item => item.id === segment.influencer_type_id);
          }
          this.cdr.markForCheck();
        }
      });

    this.influencerStore.pipe(select(getInfluencersProjectSegment))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(segments => {
        if (segments && segments.length > 0 && this.campaign) {
          this.segmentsGlobal = segments;
          this.cdr.markForCheck();
        }
      });
  }

  ngOnInit() {
    window.addEventListener('message', this.videoRecorderMessageHandler);
    window.addEventListener('message', this.handleFontBrowserMessage);
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
    this.loadWidgetAdvancedDefaultSettings();

    this.themeService.isDarkTheme$
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(isDarkTheme => {
        const nextTheme = isDarkTheme ? 'dark' : 'light';
        if (this.previewTheme === nextTheme) {
          return;
        }
        this.previewTheme = nextTheme;
        this.refreshPreviewTheme();
        this.cdr.markForCheck();
      });

    this.templateGeneratorService.forceReloadCampaign();
    this.templateGeneratorService.subscribeStore();
    this.loader$ = this.loaderService.loader$;
    this.subscribeToCampaign();
    this.socialShareSkip = localStorage.getItem('skip');
    this.watchTextConditions();
  }

  /** Keeps the conditional-text spec, which the share-link check and the counters read. */
  watchTextConditions() {
    this.textConditions?.context().pipe(takeUntil(this.unsubscriber)).subscribe((context) => {
      this.textConditionContext = context;
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit() {
    this.autoGrow(this.message().nativeElement);
    this.autoGrow(this.description().nativeElement);

    this.message().nativeElement.addEventListener('keypress', (ev) => {
      this.socialShareInfo = true;
      this.cdr.markForCheck();
    }, { once: true });
  }

  onPreviewIframeLoad() {
    try {
      const iframe = this.widgetPreviewIframe()?.nativeElement;
      const iframeDocument = iframe?.contentDocument || iframe?.contentWindow?.document;
      if (!iframeDocument) {
        return;
      }

      const isDarkTheme = document.body.classList.contains('dark-theme');
      iframeDocument.body?.classList.toggle('dark-theme', isDarkTheme);
      iframeDocument.documentElement?.classList.toggle('dark-theme', isDarkTheme);
      this.bindPreviewIframeClickHandler(iframeDocument);
    } catch (error) {
      console.warn('Unable to sync preview iframe theme', error);
    }
  }

  private setPreviewUrl(url: string): void {
    this.setVideoRecorderPageMode(false);
    this.previewUnavailableMessage = null;
    this.rawPreviewUrl = url;
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.addPreviewTheme(url));
  }

  private refreshPreviewTheme(): void {
    if (!this.rawPreviewUrl) {
      return;
    }
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.addPreviewTheme(this.rawPreviewUrl));
  }

  private addPreviewTheme(url: string): string {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      parsedUrl.searchParams.set('theme', this.previewTheme);
      return parsedUrl.toString();
    } catch (_) {
      const cleanUrl = url.replace(/([?&])theme=(dark|light)&?/g, '$1').replace(/[?&]$/, '');
      const separator = cleanUrl.includes('?') ? '&' : '?';
      return `${cleanUrl}${separator}theme=${encodeURIComponent(this.previewTheme)}`;
    }
  }

  private resolvePreviewTheme(): 'light' | 'dark' {
    return typeof document !== 'undefined' && document.body.classList.contains('dark-theme') ? 'dark' : 'light';
  }

  private setVideoRecorderPageMode(active: boolean): void {
    this.videoRecorderPageMode = active;
    document.body.classList.toggle('snoball-share-preview-recorder-open', active);
    document
      .querySelectorAll('#snoball-share-shell-iframe')
      .forEach((iframe) => iframe.classList.toggle('snoball-share-video-recorder-page-mode', active));
  }

  getMaxLength(platform: string): number {
    return this.platformLimits[platform] || -1;
  }

  // Conditional text is measured by the longest text a recipient gets.
  getCharacterCount(platform: string): number {
    const message = this.socialMedias[platform]?.message || '';
    if (platform === 'twitter') {
      return this.calculateTwitterCharacterCount(
        this.longestVariant(message, (text) => this.calculateTwitterCharacterCount(text)));
    }
    return this.longestVariant(message).length || 0; // Default: raw length for SMS, LinkedIn, etc.
  }

  getDescriptionCharacterCount(): number {
    return this.longestVariant(this.campaignMeta?.description || '').length;
  }

  // The field's maxlength: none while it holds conditional text, whose syntax and other branches
  // are not what anyone gets (the counter still turns red past the limit).
  getMessageMaxLength(platform: string): number | null {
    return this.hasConditionalText(this.socialMedias?.[platform]?.message) ? null : this.getMaxLength(platform);
  }

  getDescriptionMaxLength(): number | null {
    return this.hasConditionalText(this.campaignMeta?.description) ? null : this.metaDescriptionMaxLength;
  }

  // Past the limit while conditional text has lifted the field's maxlength.
  isDescriptionOverLimit(): boolean {
    return this.getDescriptionMaxLength() === null && this.getDescriptionCharacterCount() > this.metaDescriptionMaxLength;
  }

  hasConditionalText(text: string): boolean {
    return !!this.textConditions && this.textConditions.hasConditions(text, this.textConditionContext);
  }

  private longestVariant(text: string, measure?: (text: string) => number): string {
    return this.textConditions ? this.textConditions.longestVariant(text, this.textConditionContext, measure) : text;
  }

  calculateTwitterCharacterCount(message: string): number {
    // Regex to match URLs (basic version, can be improved)
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const urls: string[]  = message.match(urlRegex) || [];
    let count = message.length;

    // Replace each URL's length with 23 characters
    urls.forEach(url => {
      count = count - url.length + 23;
    });

    return count;
  }

  getCurrentSocialMediaPreviewing() {
    return this.currentSocialMediaPreviewing?.length ? this.currentSocialMediaPreviewing?.split('_').join(' ') : this.currentSocialMediaPreviewing;
  }

  getWidgetPreviewUrl(genericShare: boolean, influencerId?: number) {
    this.isGenericPreview = genericShare;
    this.campaignStore.dispatch(CampaignWidgetPreviewURL({
      campaignId: this.campaign.id,
      genericShare,
      influencerId
    }));
  }

  loadPreviewInfluencers(reloadPreview = false) {
    if (!this.campaign?.project_id || !this.campaign?.id) {
      return;
    }

    const segments = this.campaign.segments || [];
    if (segments.length === 0) {
      // No segment, so no influencer to page through: the preview is the campaign's own, as for a
      // campaign with no influencer yet.
      this.previewInfluencers = [];
      this.currentInfluencerIndex = 0;
      if (reloadPreview && this.campaignMeta) {
        this.loadCurrentInfluencerPreview();
      }
      return;
    }

    const segmentIds = segments.map(s => s.id).filter(id => id != null);
    const influencerTypeId = segments[0]?.influencer_type_id;

    this.influencerService.getAll({
      project_id: this.campaign.project_id,
      campaign_id: this.campaign.id,
      project_influencer_segment_ids: segmentIds,
      influencer_type_id: influencerTypeId,
      include_campaign_influencers: 'true',
      skip: 'none,campaign_email',
      perPage: 100,
      page: 1,
      options: JSON.stringify({
        includePagination: true,
        orderBy: {column: 'updated_at', dir: 'desc'},
        includeCampaignInfluencer: true
      })
    }).pipe(takeUntil(this.unsubscriber)).subscribe((resp: any) => {
      let influencers = [];
      if (resp?.success && resp?.data?.list) {
        influencers = resp.data.list.filter(inf => inf.campaign_influencer);
      } else if (resp?.success && Array.isArray(resp?.data)) {
        influencers = resp.data.filter(inf => inf.campaign_influencer);
      }

      this.previewInfluencers = influencers.sort((a, b) => {
        if (a.is_generic && !b.is_generic) {
          return -1;
        }
        if (!a.is_generic && b.is_generic) {
          return 1;
        }
        return 0;
      });
      this.currentInfluencerIndex = 0;
      if (reloadPreview && this.campaignMeta) {
        this.loadCurrentInfluencerPreview();
      }
      this.cdr.markForCheck();
    });
  }

  // The preview of the influencer the navigation is on, or the campaign's own when there is none.
  private loadCurrentInfluencerPreview() {
    const influencer = this.getCurrentInfluencer();
    if (influencer) {
      if (influencer.is_generic) {
        if (this.campaignMeta['public_widget_enabled']) {
          this.getWidgetPreviewUrl(true, influencer.id);
        } else {
          this.getWidgetPreviewUrl(false);
        }
      } else {
        this.getWidgetPreviewUrl(false, influencer.id);
      }
    } else if (this.campaignMeta['public_widget_enabled']) {
      this.getWidgetPreviewUrl(true);
    } else {
      this.getWidgetPreviewUrl(false);
    }
  }

  /** The campaign's segment: none while the campaign loads, nor for a campaign that has none. */
  getCampaignSegment() {
    return this.campaign?.segments?.[0] || null;
  }

  hasCampaignSegment(): boolean {
    return !!this.getCampaignSegment();
  }

  // Without a segment there is no influencer to list, so the navigation says so instead of loading.
  getPreviewInfluencerEmptyLabel() {
    return this.hasCampaignSegment() ? 'Loading...' : 'No influencers';
  }

  getCurrentInfluencer() {
    return this.previewInfluencers[this.currentInfluencerIndex] || null;
  }

  getCurrentInfluencerName() {
    const influencer = this.getCurrentInfluencer();
    if (!influencer) {
      return '';
    }
    return influencer.is_generic ? influencer.email : `${influencer.first_name || ''} ${influencer.last_name || ''}`.trim();
  }

  navigateToNextInfluencer() {
    if (this.currentInfluencerIndex < this.previewInfluencers.length - 1) {
      this.currentInfluencerIndex++;
      const influencer = this.getCurrentInfluencer();
      if (influencer) {
        if (influencer.is_generic) {
          if (this.campaignMeta['public_widget_enabled']) {
            this.getWidgetPreviewUrl(true, influencer.id);
          } else {
            this.getWidgetPreviewUrl(false);
          }
        } else {
          this.getWidgetPreviewUrl(false, influencer.id);
        }
      }
    }
  }

  navigateToPreviousInfluencer() {
    if (this.currentInfluencerIndex > 0) {
      this.currentInfluencerIndex--;
      const influencer = this.getCurrentInfluencer();
      if (influencer) {
        if (influencer.is_generic) {
          if (this.campaignMeta['public_widget_enabled']) {
            this.getWidgetPreviewUrl(true, influencer.id);
          } else {
            this.getWidgetPreviewUrl(false);
          }
        } else {
          this.getWidgetPreviewUrl(false, influencer.id);
        }
      }
    }
  }

  subscribeToCampaign() {
    this.campaignStore.pipe(select(getCampaignUpdate))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(campaign => {
        if (campaign) {
          if (this.previewClicked || this.previewGenericClicked) {
            if (this.previewClicked) {
              this.templateGeneratorService.widgetPreview(campaign.id, false);
            } else if (this.previewGenericClicked) {
              this.templateGeneratorService.widgetPreview(campaign.id, true);
            }
            this.previewClicked = false;
            this.previewGenericClicked = false;

            const actionButtons = this.campaignMeta.action_buttons;
            this.patchValues(campaign);
            if (actionButtons) {
              this.campaignMeta['action_buttons'] = actionButtons;
            }
            this.cdr.markForCheck();
          }
        }
      });
    this.templateGeneratorService.onCampaignLoaded
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(async campaign => {
        if (!campaign) {
          return;
        }
        this.campaign = { ...campaign };

        this.getCampaigns();
        this.loadSharePresets();
        this.influencerStore.dispatch(InfluencersTypeList({params: {influencer_fields: true}}));
        this.influencerStore.dispatch(InfluencersProjectSegment({projectId: this.campaign.project_id}));

        let shouldSave = false;

        if (campaign.meta) {
          const meta = typeof campaign.meta === 'string' ? JSON.parse(campaign.meta) : _.cloneDeep(campaign.meta);
          if (!['description', 'title', 'image', 'video', 'video_width', 'video_height', 'image_template', 'social_networks'].every(key => meta.hasOwnProperty(key))) {
            shouldSave = true;
            this.setDefault();
            this.campaignMeta = {
              ...this.campaignMeta,
              ...meta,
            };
            this.syncShareMediaOrderToMeta();
            this.patchValues({...campaign, meta: this.campaignMeta});
          } else {
            this.patchValues(campaign);
          }
        } else {
          shouldSave = true;
          this.setDefault(true);
          this.setCampaignProjectWidgetSettings(campaign);
        }

        if (this.campaignMeta && !this.campaignMeta.hasOwnProperty('influencer_fields_active')) {
          const hasActiveConfiguredInfluencerFields = Array.isArray(this.campaignMeta?.influencer_fields) &&
            this.campaignMeta.influencer_fields.some(field => !['influencer_picture', 'influencer_video', 'video_url'].includes(field.key) && field.enabled);
          this.campaignMeta['influencer_fields_active'] = hasActiveConfiguredInfluencerFields;
          shouldSave = true;
        }
        if (this.campaignMeta) {
          for (const setting of this.campaignWidgetOverrideSettings) {
            if (!this.campaignMeta.hasOwnProperty(setting.useGlobalKey)) {
              this.campaignMeta[setting.useGlobalKey] = setting.valueType === 'boolean'
                ? typeof this.campaignMeta[setting.key] !== 'boolean'
                : this.campaignMeta[setting.key] == null;
              if (setting.valueType === 'boolean') {
                shouldSave = true;
              }
            }
            if (!this.campaignMeta.hasOwnProperty(setting.key)) {
              this.campaignMeta[setting.key] = setting.defaultValue;
            }
          }
          this.inheritUnsetCampaignWidgetFields();
        }

        this.ensureCampaignWidgetAdvancedDefaults();
        if (this.campaignMeta && (!this.campaignMeta['action_buttons'] || this.campaignMeta['action_buttons'].length === 0)) {
          this.campaignMeta['action_buttons'] = [
            {
              name: '',
              title: '',
              icon: null,
              actions: [
                { type: '' }
              ]
            }
          ];
        } else {
          this.campaignMeta['action_buttons'] = _.cloneDeep(this.campaignMeta['action_buttons']);
          if (this.ensureUniqueWidgetActionNames(this.campaignMeta['action_buttons'])) {
            shouldSave = true;
          }
          // Ensure widget_settings sub-object exists on any saved set_widget_settings actions
          for (const btn of this.campaignMeta['action_buttons']) {
            for (const act of (btn.actions || [])) {
              if (act.type === 'set_widget_settings' && !act.widget_settings) {
                act.widget_settings = { language: null, header_1: null, header_2: null, header_3: null, custom_minimized_text: null, promo_text: null };
              }
            }
          }
        }
        if (this.campaignMeta && !this.campaignMeta['default_action_button_index']) {
          this.campaignMeta['default_action_button_index'] = 0;
        }
        if (this.campaignMeta && !this.campaignMeta['action_buttons_active']) {
          this.campaignMeta['action_buttons_active'] = false;
        }
        if (this.campaignMeta && !this.campaignMeta['action_buttons_required']) {
          this.campaignMeta['action_buttons_required'] = false;
        }
        if (this.campaignMeta && !this.campaignMeta['influencer_fields']) {
          this.campaignMeta['influencer_fields'] = this.createDefaultInfluencerFields();

          if (this.campaignMeta && this.campaignMeta['custom_fields']) {
            this.campaignMeta['influencer_fields'] = [
              ...this.createDefaultSystemInfluencerFields(),
              ...this.createDefaultPrimaryInfluencerFields(),
              ...this.campaignMeta['custom_fields'].map(field => this.normalizeInfluencerField({ ...field, field_type: 'custom' }))
            ];
          }
        }
        this.campaignMeta['influencer_fields'] = this.normalizeInfluencerFields(_.cloneDeep(this.campaignMeta['influencer_fields']));
        if (this.campaignMeta && !shouldSave) {
          this.loadPreviewInfluencers(true);
        }
        if (this.campaign?.project_id && this.getCampaignWidgetSettingValue('allow_influencers_to_use_ai_avatar_in_widget')) {
          this.fetchWidgetAITemplates();
        }
        this.validateSocialMessage();
        // A campaign without a segment has no influencer type; its variables load without one.
        const influencerTypeId = this.getCampaignSegment()?.influencer_type_id;
        this.templateGeneratorService.loadVariables({
          ...(influencerTypeId ? {influencerTypeId} : {}),
          campaignId: this.campaign.id
        }, (vars) => {
          const campaignPageUrlVariable = (Object.values(vars) as any[]).find((value) => value?.key?.toLowerCase() ===
              this.influencerCampaignPageUrlVariable.toLowerCase());
          const notRenderedForSocialNetworks =
            campaignPageUrlVariable?.notRenderedForSocialNetworks;
          if (Array.isArray(notRenderedForSocialNetworks)) {
            this.campaignPageUrlNotRenderedForSocialNetworks =
              notRenderedForSocialNetworks.map((socialNetwork) => String(socialNetwork).toLowerCase());
          }
          const result = [];
          Object.entries(vars).forEach(([key, value]) => {
            if (value.hasOwnProperty('group') && value['group']) {
              if (!result[value['group']]) {
                result[value['group']] = [];
              }
              result[value['group']].push({
                name: value['title'].replace(value['group'].toString().toLowerCase().trim(), ''),
                key: value['alias'] ? `#${value['alias']}#` : value['key'],
                valueType: value['valueType']
              });
            } else {
              if (!result['generic']) {
                result['generic'] = [];
              }
              result['generic'].push({
                name: value['title'],
                key: value['key'],
                valueType: value['valueType']
              });
            }
          });
          this.variables = result;
          this.validateSocialMessage();
          this.cdr.markForCheck();
        });

        if (shouldSave) {
          this.onSave(() => {
            if (this.campaignMeta) {
              this.loadPreviewInfluencers();

              if (this.campaignMeta['public_widget_enabled']) {
                this.getWidgetPreviewUrl(true);
              } else {
                this.getWidgetPreviewUrl(false);
              }
            }
          });
        }

        this.initStep();
        this.cdr.markForCheck();

        // this.templateGeneratorService.loadClientTemplate({ templateTypeId: LANDING_PAGE_TEMPLATE_TYPE_ID },
        //   { createIfNotExist: false, forceTouch: false });
        // this.templateGeneratorService.onTemplateChanged[LANDING_PAGE_TEMPLATE_TYPE_ID]
        //   .pipe(takeUntil(this.unsubscriber))
        //   .subscribe((template) => {
        //     if (!template) {
        //       return;
        //     }
        //     this.landingTemplate = template;
        //   });
      });
  }

  rearrangeSocialNetworkPositions(panelWidth: number, positions: any[]) {
    const itemWidth = 36;
    const itemHeight = 36;
    const paddingX = 20;
    const paddingY = 0;

    const perRow = Math.max(1, Math.floor(panelWidth / itemWidth));
    let sorted = [...positions].sort((a, b) => a.order - b.order);

    sorted = sorted.map((pos, i) => {
      const row = Math.floor(i / perRow);
      const col = i % perRow;

      return {
        ...pos,
        x: col * itemWidth + paddingX,
        y: row * itemHeight + paddingY,
        order: i,
      };
    });

    sorted.forEach((pos, index) => {
      const target = this.positions.find((p) => p.id === pos.id);
      if (target) {
        target.x = pos.x;
        target.y = pos.y;
        target.order = index;
      }
    });
  };

  normalizeShareMediaOrder(order: any): string[] {
    const source = Array.isArray(order) ? order : [];
    const normalized = source.filter((item, index) => this.defaultShareMediaOrder.includes(item) && source.indexOf(item) === index);

    return [
      ...normalized,
      ...this.defaultShareMediaOrder.filter(item => !normalized.includes(item))
    ];
  }

  syncShareMediaOrderToMeta(order = this.campaignMeta?.share_media_order) {
    this.shareMediaOrder = this.normalizeShareMediaOrder(order);
    if (this.campaignMeta) {
      this.campaignMeta.share_media_order = [...this.shareMediaOrder];
    }
  }

  setShareMediaOrderFirst(firstMedia: string) {
    const first = this.defaultShareMediaOrder.includes(firstMedia)
      ? firstMedia
      : this.defaultShareMediaOrder[0];

    this.syncShareMediaOrderToMeta([
      first,
      ...this.defaultShareMediaOrder.filter(item => item !== first)
    ]);
    this.onSettingsChange(null);
  }

  patchValues(campaign) {
    this.campaignMeta = {
      ...this.campaignMeta,
      ...((typeof campaign.meta === 'string') ? JSON.parse(campaign.meta) : _.cloneDeep(campaign.meta))
    };
    this.syncShareMediaOrderToMeta();
    this.videoUploadEnabled = !!this.campaignMeta?.video;
    this.restoreSelectedSharePresetFromMeta();
    this.socialPlatformVisibility = {
      ...this.socialPlatformVisibility,
    };
    this.campaignMeta.social_networks = this.campaignMeta.social_networks || {};

    const socialNetworksKeys = Object.keys(this.campaignMeta.social_networks);
    socialNetworksKeys.forEach((key) => {
      if (this.campaignMeta.social_networks?.[key]?.hasOwnProperty('active')) {
        this.socialPlatformVisibility[key] = this.campaignMeta.social_networks[key]['active'];
      } else {
        this.campaignMeta.social_networks[key]['active'] = this.socialPlatformVisibility[key];
      }
    });
    this.setCampaignProjectWidgetSettings(campaign);
    const { facebook, linkedin, twitter, whatsapp, slack, instagram, email, facebook_messenger, microsoft_teams, sms, zalo, line, wechat, bluesky, telegram, vk, viber, signal, tiktok } = this.campaignMeta.social_networks;
    this.socialMedias = {
      ...this.socialMedias,
      facebook: {
        ...this.socialMedias.facebook,
        ...facebook
      },
      linkedin: {
        ...this.socialMedias.linkedin,
        ...linkedin
      },
      twitter: {
        ...this.socialMedias.twitter,
        ...twitter
      },
      whatsapp: {
        ...this.socialMedias.whatsapp,
        ...whatsapp
      },
      slack: {
        ...this.socialMedias.slack,
        ...slack
      },
      instagram: {
        ...this.socialMedias.instagram,
        ...instagram
      },
      email: {
        ...this.socialMedias.email,
        ...email
      },
      facebook_messenger: {
        ...this.socialMedias.facebook_messenger,
        ...facebook_messenger
      },
      microsoft_teams: {
        ...this.socialMedias.microsoft_teams,
        ...microsoft_teams
      },
      sms: {
        ...this.socialMedias.sms,
        ...sms
      },
      zalo: {
        ...this.socialMedias.zalo,
        ...zalo
      },
      line: {
        ...this.socialMedias.line,
        ...line
      },
      wechat: {
        ...this.socialMedias.wechat,
        ...wechat
      },
      bluesky: {
        ...this.socialMedias.bluesky,
        ...bluesky
      },
      telegram: {
        ...this.socialMedias.telegram,
        ...telegram
      },
      vk: {
        ...this.socialMedias.vk,
        ...vk
      },
      viber: {
        ...this.socialMedias.viber,
        ...viber
      },
      signal: {
        ...this.socialMedias.signal,
        ...signal
      },
      tiktok: {
        ...this.socialMedias.tiktok,
        ...tiktok
      }
    };
    this.positions.forEach(pos => {
      const media = this.socialMedias[pos.id];
      if (media) {
        pos.y = 0;
        pos.x = 0;
        pos.active = media.active ?? pos.active;
        pos.order = media.order ?? pos.order;
      }
    });
    this.rearrangeSocialNetworkPositions(this.panelWidth, this.positions);
    this.currentSocialMediaPreviewing = [...this.positions].sort((a, b) => a.order - b.order).find(pos => pos.active)?.id || 'facebook';

    setTimeout(() => {
      this.autoGrow(this.message().nativeElement);
      this.autoGrow(this.description().nativeElement);
    }, 200);
  }

  private setCampaignProjectWidgetSettings(campaign: any) {
    const settings = campaign?.project?.effective_widget_settings ?? campaign?.project?.widget_settings;
    if (!settings) {
      this.widget_Settings = {};
      return;
    }
    this.widget_Settings = typeof settings === 'string'
      ? {...JSON.parse(settings)}
      : _.cloneDeep(settings);
  }

  socialNetworkLabel(socialNetwork: string) {
    return String(socialNetwork || '')
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  isCampaignPageUrlRenderedForSocialNetwork(socialNetwork: string) {
    const normalizedSocialNetwork = String(socialNetwork || '').toLowerCase();
    return !this.campaignPageUrlNotRenderedForSocialNetworks.includes(
      normalizedSocialNetwork
    );
  }

  socialMessageContainsCampaignPageUrl(socialNetwork: string) {
    return hasVariableToken(this.socialMedias?.[socialNetwork]?.message, this.influencerCampaignPageUrlVariable);
  }

  // Every recipient's message keeps the campaign page link: outside conditional text, or in every
  // branch of an if/else. A condition the render removes never counts.
  socialMessageKeepsCampaignPageUrl(socialNetwork: string) {
    const message = this.socialMedias?.[socialNetwork]?.message;
    const token = this.influencerCampaignPageUrlVariable;
    return this.textConditions
      ? this.textConditions.alwaysHas(message, token, this.textConditionContext)
      : hasVariableToken(message, token);
  }

  validateSocialMessage() {
    this.socialMessageError = {
      facebook: false,
      twitter: false,
      linkedin: false,
      whatsapp: false,
      slack: false,
      instagram: false,
      email: false,
      facebook_messenger: false,
      microsoft_teams: false,
      sms: false,
      zalo: false,
      line: false,
      wechat: false,
      bluesky: false,
      telegram: false,
      vk: false,
      viber: false,
      signal: false,
      tiktok: false,
    };
    let isValid = true;
    this.currentSocialSharePlatforms.every(item => {
      if (this.isCampaignPageUrlRenderedForSocialNetwork(item) && !this.socialMessageKeepsCampaignPageUrl(item)) {
        this.socialMessageError[item] = true;
        isValid = false;
        return false;
      }
      return true;
    });
    return isValid;
  }

  setDefault(activateNewSocialNetworks = false) {
    this.campaignMeta = {
      description: 'Invite your connections. #ProjectTitle# is an event not to be missed.',
      title: 'Claim Your Seat.',
      image: '',
      image_width: '',
      image_height: '',
      video: '',
      video_width: '',
      video_height: '',
      video_poster: '',
      share_media_order: [...this.defaultShareMediaOrder],
      image_template: false
    };
    this.syncShareMediaOrderToMeta();
    this.socialMedias = {
      facebook: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      linkedin: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      twitter: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      whatsapp: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      slack: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      instagram: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      email: {
        title: '',
        message: `Hi,

Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#

Best,
#InfluencerFName#`
      },
      facebook_messenger: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      microsoft_teams: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      sms: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      zalo: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      line: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      wechat: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      bluesky: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      telegram: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      vk: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      viber: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      signal: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
      tiktok: {
        message: `Join me in attending #ProjectHashtag# where professionals will learn and network on aligning strategies to business priorities and opportunities. Register today! #InfluencerCampaignPageUrl#`
      },
    };

    if (activateNewSocialNetworks) {
      ['signal', 'tiktok'].forEach(network => {
        this.socialPlatformVisibility[network] = true;
        this.socialMedias[network].active = true;
        const position = this.positions.find(item => item.id === network);
        if (position) {
          position.active = true;
        }
      });
    }

    this.rearrangeSocialNetworkPositions(this.panelWidth, this.positions);
    this.cdr.markForCheck();
    setTimeout(() => {
      this.autoGrow(this.message().nativeElement);
      this.autoGrow(this.description().nativeElement);
    }, 200);
  }

  initStep() {
    const params = {};

    params['projectId'] = this.campaign.project_id;
    params['campaignId'] = this.campaign.id;
    params['campaignName'] = this.campaign.name;

    this.step = { title: 'Share', params };
  }

  async onSocialMediaImageSelect(event) {
    try {
      await this.selectSocialMediaImage(event);
    } finally {
      this.cdr.markForCheck();
    }
  }

  private async selectSocialMediaImage(event) {
    if (event && event.target && event.target.files && event.target.files.length > 0) {
      const { target: { files } } = event;
      let uploadFile = files[0];
      const contentType = files[0].name.split('.').pop();
      this.uploadMediaType = this.uploadTab === 'video_poster' ? 'video_poster' : 'image';
      if (this.uploadTab === 'video' || this.uploadTab === 'video_poster') {
        this.videoUploadEnabled = true;
      }
      if (uploadFile.type.includes('image')) {
        this.isVideoUploaded = false;
        const isVideoPosterUpload = this.uploadMediaType === 'video_poster';
        const videoWidth = Number(this.campaignMeta?.video_width);
        const videoHeight = Number(this.campaignMeta?.video_height);
        if (isVideoPosterUpload && (!this.getVideoPreview() || !videoWidth || !videoHeight)) {
          this.toastr.error('Please upload a video before uploading a video cover.');
          return;
        }
        if (contentType !== 'gif') {
          // Crop file
          const croppedImage: File | boolean = await this.cropImage(files[0], isVideoPosterUpload ? {
            aspectRatio: videoWidth / videoHeight,
            portrait: videoHeight > videoWidth,
            landscape: videoWidth > videoHeight
          } : null);
          // validate
          if (croppedImage === false) {
            // Clear file
            return;
          }
          uploadFile = croppedImage;
        }
        if (isVideoPosterUpload) {
          try {
            uploadFile = await this.resizeImageToDimensions(uploadFile, videoWidth, videoHeight);
          } catch (e) {
            this.toastr.error(`Video cover must be an image that can be resized to ${videoWidth}x${videoHeight}px.`);
            return;
          }
        }
      } else if (uploadFile.type.includes('video')) {
        this.isVideoUploaded = true;
        this.uploadMediaType = 'video';
        if (!await this.validateVideo(uploadFile, contentType)) {
          this.isVideoUploaded = false;
          this.uploadMediaType = 'image';
          this.contentFile = null;
          this.contentSignedUrl = null;
          this.validatedVideoInfo = null;
          return;
        }
        const videoInfo: any = this.validatedVideoInfo || await this.getVideoInfo(uploadFile);
        this.campaignMeta = {
          ...this.campaignMeta,
          video_width: videoInfo.width,
          video_height: videoInfo.height,
          ...(videoInfo.duration ? {video_duration: videoInfo.duration} : {})
        };
      } else {
        this.isVideoUploaded = false;
        this.toastr.error('Only image or video files are allowed');
        return;
      }
      const selectedUploadMediaType = this.uploadMediaType;
      this.pendingMediaUploads[selectedUploadMediaType] = uploadFile;
      this.contentFile = null;
      this.contentSignedUrl = null;
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(uploadFile);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      }).then(data => {
        if (selectedUploadMediaType === 'video') {
          this.videoPreviewUrl = data as string;
          this.campaignMeta = {
            ...this.campaignMeta,
            video: data,
            video_validation: null
          };
          this.onSettingsChange(null);
          this.cdr.markForCheck();

        } else if (selectedUploadMediaType === 'video_poster') {
          this.videoPosterPreviewUrl = data as string;
          this.campaignMeta = {
            ...this.campaignMeta,
            video_poster: data
          };
          this.onSettingsChange(null);
          this.cdr.markForCheck();

        } else {
          const img = new Image();
          img.src = data as string;
          img.onload = () => {
            const width = img.width;
            const height = img.height;
            this.campaignMeta = {
              ...this.campaignMeta,
              image: data,
              image_template: this.keepsTemplateForUploadedImage(),
              image_width: width,
              image_height: height
            };

            this.onSettingsChange(null);
            this.cdr.markForCheck();
          };
        }
      });
    }
  }

  addVideoUrl() {
    this.contentSignedUrl = null;
    this.contentFile = null;
    this.contentType = 'video';
    this.videoUploadEnabled = true;
    this.campaignMeta = {
      ...this.campaignMeta,
      video: this.videoURL,
      video_width: this.videoWidth,
      video_height: this.videoHeight,
      video_validation: null
    };
  }

  async validateVideo(uploadFile, contentType) {
    const extension = String(contentType || '').toLowerCase();
    const mimeType = String(uploadFile?.type || '').toLowerCase();
    if (extension !== this.videoUploadPolicy.format || (mimeType && mimeType !== 'video/mp4')) {
      this.toastr.error('Only MP4 video files are allowed');
      return false;
    }
    if (uploadFile.size > this.videoUploadPolicy.maxSizeBytes) {
      this.toastr.error('Video file size must be 300MB or less');
      return false;
    }

    let videoInfo: any;
    try {
      videoInfo = await this.getVideoInfo(uploadFile);
      this.validatedVideoInfo = videoInfo;
    } catch (e) {
      this.toastr.error('Unable to read video metadata. Please choose a valid MP4 video.');
      return false;
    }
    const aspectRatio = videoInfo.width && videoInfo.height ? videoInfo.width / videoInfo.height : null;
    console.log('Campaign share video metadata before upload', {
      name: uploadFile.name,
      extension,
      mimeType,
      sizeBytes: uploadFile.size,
      durationSeconds: videoInfo.duration,
      frameRate: videoInfo.frameRate,
      width: videoInfo.width,
      height: videoInfo.height,
      aspectRatio,
    });
    if (
      videoInfo.width < this.videoUploadPolicy.minWidth ||
      videoInfo.width > this.videoUploadPolicy.maxWidth ||
      videoInfo.height < this.videoUploadPolicy.minHeight ||
      videoInfo.height > this.videoUploadPolicy.maxHeight
    ) {
      this.toastr.error(`Video dimensions must fit within ${this.videoUploadPolicy.minWidth}x${this.videoUploadPolicy.minHeight}px and ${this.videoUploadPolicy.maxWidth}x${this.videoUploadPolicy.maxHeight}px`);
      return false;
    }
    if (aspectRatio < this.videoUploadPolicy.minAspectRatio || aspectRatio > this.videoUploadPolicy.maxAspectRatio) {
      this.toastr.error('Video aspect ratio must be between 9:16 and 1.91:1');
      return false;
    }
    if (
      videoInfo.duration < this.videoUploadPolicy.minDurationSeconds ||
      videoInfo.duration > this.videoUploadPolicy.maxDurationSeconds
    ) {
      this.toastr.error(`Video duration must be between ${this.videoUploadPolicy.minDurationSeconds} and ${this.videoUploadPolicy.maxDurationSeconds} seconds`);
      return false;
    }
    if (
      videoInfo.frameRate &&
      (videoInfo.frameRate < this.videoUploadPolicy.minFrameRate || videoInfo.frameRate > this.videoUploadPolicy.maxFrameRate)
    ) {
      this.toastr.error(`Video frame rate must be between ${this.videoUploadPolicy.minFrameRate} and ${this.videoUploadPolicy.maxFrameRate} fps`);
      return false;
    }
    return true;
  }

  getVideoInfo(file) {
    return new Promise((resolve, reject) => {
      const info: any = {
        duration: '',
        frameRate: null,
        height: '',
        width: ''
      };
      const video = document.createElement('video');
      video.preload = 'metadata';
      let objectUrl = '';
      const cleanup = () => {
        video.pause();
        if (objectUrl) {
          window.URL.revokeObjectURL(objectUrl);
          objectUrl = '';
        }
      };
      const resolveInfo = () => {
        cleanup();
        resolve(info);
      };
      video.onloadedmetadata = () => {
        info.duration = video.duration;
        info.width = video.videoWidth;
        info.height = video.videoHeight;
        if (typeof (video as any).requestVideoFrameCallback !== 'function' || !Number.isFinite(video.duration) || video.duration <= 0) {
          resolveInfo();
          return;
        }

        let firstMediaTime = null;
        let lastMediaTime = null;
        let frames = 0;
        const maxSampleSeconds = Math.min(video.duration, 2);
        const startedAt = Date.now();
        const sampleFrameRate = (_now, metadata) => {
          const mediaTime = Number(metadata?.mediaTime) || 0;
          if (firstMediaTime === null) {
            firstMediaTime = mediaTime;
          }
          lastMediaTime = mediaTime;
          frames++;
          const sampledSeconds = lastMediaTime - firstMediaTime;
          if (sampledSeconds >= maxSampleSeconds || Date.now() - startedAt > 3500 || video.ended) {
            if (sampledSeconds > 0 && frames > 1) {
              info.frameRate = Math.round(((frames - 1) / sampledSeconds) * 100) / 100;
            }
            resolveInfo();
            return;
          }
          (video as any).requestVideoFrameCallback(sampleFrameRate);
        };

        video.muted = true;
        video.currentTime = 0;
        (video as any).requestVideoFrameCallback(sampleFrameRate);
        video.play().catch(() => resolveInfo());
      };
      video.onerror = () => {
        cleanup();
        reject(new Error('Unable to read video metadata'));
      };
      objectUrl = URL.createObjectURL(file);
      video.src = objectUrl;
    });
  }

  resizeImageToDimensions(file: File, width: number, height: number): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d');
          if (!context) {
            reject(new Error('Unable to resize image'));
            return;
          }
          context.drawImage(image, 0, 0, width, height);
          canvas.toBlob(blob => {
            if (!blob) {
              reject(new Error('Unable to resize image'));
              return;
            }
            const extension = file.type === 'image/png' ? 'png' : 'jpg';
            const name = file.name.replace(/\.[^.]+$/, '') + `-${width}x${height}.${extension}`;
            resolve(new File([blob], name, { type: blob.type }));
          }, file.type === 'image/png' ? 'image/png' : 'image/jpeg', 0.92);
        };
        image.onerror = () => reject(new Error('Unable to read image'));
        image.src = reader.result as string;
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

  getVideoFileSize(size) {
    let i = 0;
    while (size > 900) {
      size /= 1024;
      i++;
    }
    return (Math.round(size * 100) / 100);
  }

  onAddVariablesButtonClick(variablesFor: any) {
    this.isForMeta = false;
    this.variablesFor = variablesFor;
  }

  onMetaVariablesButtonClick(variablesFor: any) {
    this.isForMeta = true;
    this.variablesFor = variablesFor;
  }

  updateValue(event, textFor) {
    // this.socialMedias[this.currentSocialMediaPreviewing]['page'][textFor] = event.target.value;
    this.campaignMeta[textFor] = event.target.value;
    this.onSettingsChange(null, 4, false);
  }

  onVariableClick(variable, element = null) {
    if (this.isForMeta) {
      if (!this.campaignMeta[this.variablesFor]) {
        this.campaignMeta[this.variablesFor] = '';
      }
      const value = this.campaignMeta[this.variablesFor];
      const varValue = variable.key;
      if (element && element.selectionStart || element.selectionStart === '0' || element.selectionStart === 0) {
        const startPos = element.selectionStart;
        const endPos = element.selectionEnd;
        if (element.selectionStart === '0' || element.selectionStart === 0) {
          this.campaignMeta[this.variablesFor] = `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`;
        } else {
          this.campaignMeta[this.variablesFor] = `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`;
        }
      } else {
        this.campaignMeta[this.variablesFor] = `${value}${varValue}`;
      }
    } else {
      if (!this.socialMedias[this.currentSocialMediaPreviewing]) {
        this.socialMedias[this.currentSocialMediaPreviewing] = {};
        if (!this.socialMedias[this.currentSocialMediaPreviewing][this.variablesFor]) {
          this.socialMedias[this.currentSocialMediaPreviewing][this.variablesFor] = '';
        }
      }
      const value = this.socialMedias[this.currentSocialMediaPreviewing][this.variablesFor];
      const varValue = variable.key;
      if (element && element.selectionStart || element.selectionStart === '0' || element.selectionStart === 0) {
        const startPos = element.selectionStart;
        const endPos = element.selectionEnd;
        if (element.selectionStart === '0' || element.selectionStart === 0) {
          this.socialMedias[this.currentSocialMediaPreviewing][this.variablesFor] = `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`;
        } else{
          this.socialMedias[this.currentSocialMediaPreviewing][this.variablesFor] = `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`;
        }
      } else {
        this.socialMedias[this.currentSocialMediaPreviewing][this.variablesFor] = `${value}${varValue}`;
      }
    }
    this.variablesFor = '';
    this.onSettingsChange(null, 2, false);
  }

  onVariableClickForActionTriggerCustomFields(variable, button, action, element) {
    const value = action.value || '';
    const varValue = variable.key;

    if (element && element?.selectionStart || element?.selectionStart === '0' || element?.selectionStart === 0) {
      const startPos = element.selectionStart;
      const endPos = element.selectionEnd;
      if (element.selectionStart === '0' || element.selectionStart === 0) {
        action.value = `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`;
      } else {
        action.value = `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`;
      }
    } else {
      action.value = `${value}${varValue}`;
    }

    this.onSettingsChange(null, 2, false);
  }

  // A variable, also one with a default text (#Key|Default text#).
  containsHashPattern(str) {
    const regex = /#\w+(?:\|[^#<>\r\n]{1,500})?#/;
    return regex.test(str);
  }

  getPreText() {
    return this.currentSocialMediaPreviewing === 'email' ? 'Message' : (this.getCurrentSocialMediaPreviewing() + ' Post');
  }

  changeCheckBox(event) {
    this.socialPlatformVisibility[this.currentSocialMediaPreviewing] = event.target.checked;
    this.onSettingsChange(null);
  }

  onBackButonClick() {
    if (this.campaign.landing_page_status === 'skipped') {
      this.router.navigateByUrl(routes.addInfluencers({ projectId: this.campaign.project_id }, { campId: this.campaign.id }));
    } else {
      this.router.navigateByUrl(
        routes.campaignTemplate({
          projectId: this.campaign.project_id,
          campaignId: this.campaign.id
        })
      );
    }
  }

  // Runs one save job: validates, uploads anything pending, then PUTs campaignMeta as it
  // stands when the job actually starts (not when it was queued). Never rejects, so a
  // failed job never blocks the next one in the chain.
  private async runQueuedSaveJob(targetSeq: number): Promise<'saved' | 'invalid' | 'failed'> {
    if (!this.validateSocialMessage()) {
      return 'invalid';
    }
    try {
      if (this.hasPendingMediaUploads()) {
        await this.uploadPendingMediaUploads();
      }
      const success = await this.saveData();
      if (!success) {
        return 'failed';
      }
      if (targetSeq > this.savedSeq) {
        this.savedSeq = targetSeq;
      }
      return 'saved';
    } catch (error) {
      return 'failed';
    } finally {
      this.cdr.markForCheck();
    }
  }

  // Chains every save on a single promise so only one PUT is ever in flight and saves
  // never land out of order. Each job reads campaignMeta only once it actually starts.
  enqueueSave(): Promise<'saved' | 'invalid' | 'failed'> {
    const targetSeq = this.changeSeq;
    const job = this.saveQueue.then(
      () => this.runQueuedSaveJob(targetSeq),
      () => this.runQueuedSaveJob(targetSeq)
    );
    this.saveQueue = job;
    return job;
  }

  // Explicit save trigger (Save & Exit, Next, the expand-popup, uploads). Cancels whatever
  // autosave debounce is pending -- that change is captured by this save instead -- and
  // runs the callback only once this job actually succeeds.
  onSave(callBack: () => void = () => {}): Promise<'saved' | 'invalid' | 'failed'> {
    if (this.settingChangedDebounceTimer) {
      clearTimeout(this.settingChangedDebounceTimer);
      this.settingChangedDebounceTimer = null;
    }
    return this.enqueueSave().then(status => {
      if (status === 'saved') {
        callBack();
      }
      this.cdr.markForCheck();
      return status;
    });
  }

  // Used by the leave guard and beforeunload: if a debounce is pending it is promoted to a
  // save right now, otherwise this just waits for whatever is already queued to finish.
  flushPendingSave(): Promise<'saved' | 'invalid' | 'failed'> {
    if (this.settingChangedDebounceTimer) {
      clearTimeout(this.settingChangedDebounceTimer);
      this.settingChangedDebounceTimer = null;
      return this.enqueueSave();
    }
    return this.saveQueue;
  }

  hasUnsavedChanges(): boolean {
    return this.savedSeq !== this.changeSeq;
  }

  hasPendingMediaUploads() {
    return !!(
      this.pendingMediaUploads.image ||
      this.pendingMediaUploads.video ||
      this.pendingMediaUploads.video_poster ||
      this.pendingActionVideoUploads.size
    );
  }

  async uploadPendingMediaUploads() {
    this.loaderService.show();
    try {
      const uploadOrder = ['image', 'video', 'video_poster'];
      for (const mediaType of uploadOrder) {
        const file = this.pendingMediaUploads[mediaType];
        if (!file) {
          continue;
        }

        const signedResp: any = await lastValueFrom(this.awsService.getAwsSignedUrl(file.name, file.type));
        if (!signedResp?.success || !signedResp?.data?.url) {
          throw new Error(this.loaderService.getErrorMessage(signedResp));
        }

        await lastValueFrom(this.awsService.uploadFileToSignedUrl(signedResp.data.url, file));
        const pathUrl = signedResp.data.url.split('?')[0];

        if (mediaType === 'video') {
          this.campaignMeta = {
            ...this.campaignMeta,
            video: pathUrl,
            video_validation: null
          };
          this.videoPreviewUrl = '';
        } else if (mediaType === 'video_poster') {
          this.campaignMeta = {
            ...this.campaignMeta,
            video_poster: pathUrl
          };
          this.videoPosterPreviewUrl = '';
        } else {
          this.campaignMeta = {
            ...this.campaignMeta,
            image: pathUrl,
            image_template: this.keepsTemplateForUploadedImage()
          };
        }

        this.pendingMediaUploads[mediaType] = null;
        this.cdr.markForCheck();
      }
      for (const [action, file] of Array.from(this.pendingActionVideoUploads.entries())) {
        const signedResp: any = await lastValueFrom(this.awsService.getAwsSignedUrl(
          file.name,
          'video/mp4'
        ));
        if (!signedResp?.success || !signedResp?.data?.url) {
          throw new Error(this.loaderService.getErrorMessage(signedResp));
        }

        await lastValueFrom(this.awsService.uploadFileToSignedUrl(signedResp.data.url, file));
        action.value = signedResp.data.url.split('?')[0];
        this.clearActionVideoMetadata(action);
        this.clearPendingActionVideoUpload(action);
      }
      this.contentFile = null;
      this.contentSignedUrl = null;
      this.uploadMediaType = 'image';
      this.isVideoUploaded = false;
      this.loaderService.hide();
    } catch (error) {
      this.loaderService.hide(true);
      this.toastr.error(this.loaderService.getErrorMessage(error));
      throw error;
    }
  }

  getCampaignUpdateErrorMessage(error) {
    const videoErrors = error?.data?.video_validation?.errors || error?.error?.data?.video_validation?.errors;
    if (Array.isArray(videoErrors) && videoErrors.length) {
      return videoErrors.join(', ');
    }
    return this.loaderService.getErrorMessage(error);
  }

  applyCampaignUpdateValidationError(error) {
    const videoValidation = error?.data?.video_validation || error?.error?.data?.video_validation;
    if (videoValidation) {
      this.campaignMeta = {
        ...this.campaignMeta,
        video_validation: videoValidation
      };
    }
  }

  // Returns whether the PUT actually landed, so the save queue can tell 'saved' from
  // 'failed' (or a validation reject, which returns false without calling the API at all).
  async saveData(): Promise<boolean> {
    const actionButtons = this.getValidatedActionButtons();
    if (!actionButtons) {
      return false;
    }

    const customFields = this.validateInfluencerFieldsForSave();
    if (!customFields) {
      return false;
    }

    this.syncShareMediaOrderToMeta();

    const metaValues = {
      ...{
        ...this.campaignMeta,
        action_buttons: actionButtons,
        influencer_fields: customFields
      },
      social_networks: this.socialMedias
    };
    // const socialMediaKeys = Object.keys(metaValues.social_networks);
    // socialMediaKeys.forEach((key) => {
    //    metaValues.social_networks[key]['active'] = this.socialPlatformVisibility[key];
    // });
    this.positions.forEach(pos => {
      metaValues.social_networks[pos.id]['order'] = pos.order;
      metaValues.social_networks[pos.id]['active'] = this.socialPlatformVisibility[pos.id];
      metaValues.social_networks[pos.id]['x'] = pos.x;
      metaValues.social_networks[pos.id]['y'] = pos.y;
    });
    // this.campaignStore.dispatch(CampaignUpdate({campaign: {meta: metaValues}, campaignId: this.campaign.id}));

    this.loaderService.show();
    return await lastValueFrom(this.campaignService.updateCampaign({ meta: metaValues }, this.campaign.id).pipe(
      map((resp: any) => {
        if (resp.success) {
          this.loaderService.hide();
          this.campaignStore.dispatch(CampaignUpdateSuccess({ campaign: resp.data }));
          return true;
        }
        this.loaderService.hide(true);
        this.campaignStore.dispatch(CampaignUpdateError({ error: this.loaderService.getErrorMessage(resp) }));
        return false;
      }),
      catchError(error => {
        this.loaderService.hide(true);
        this.campaignStore.dispatch(CampaignUpdateError({ error: this.loaderService.getErrorMessage(error) }));
        return of(false);
      })
    ));
  }

  private ensureUniqueWidgetActionNames(actionButtons: Array<{name?: string}>): boolean {
    const reservedNames = new Set(
      actionButtons
        .map((button) => typeof button.name === 'string' ? button.name.trim().toLowerCase() : '')
        .filter((name) => name !== '')
    );
    const usedNames = new Set<string>();
    const nextSuffixes = new Map<string, number>();
    let changed = false;

    for (const button of actionButtons) {
      const normalizedName = typeof button.name === 'string'
        ? button.name.trim().toLowerCase()
        : '';
      if (!normalizedName) {
        continue;
      }
      if (!usedNames.has(normalizedName)) {
        usedNames.add(normalizedName);
        continue;
      }

      const baseName = button.name.trim();
      let suffix = nextSuffixes.get(normalizedName) || 2;
      let candidateName;
      let normalizedCandidateName;

      do {
        candidateName = `${baseName}-${suffix}`;
        normalizedCandidateName = candidateName.trim().toLowerCase();
        suffix++;
      } while (
        reservedNames.has(normalizedCandidateName) ||
        usedNames.has(normalizedCandidateName)
      );

      button.name = candidateName;
      reservedNames.add(normalizedCandidateName);
      usedNames.add(normalizedCandidateName);
      nextSuffixes.set(normalizedName, suffix);
      changed = true;
    }

    return changed;
  }

  getValidatedActionButtons() {
    const actionButtons = _.cloneDeep(this.campaignMeta.action_buttons || []).filter(button =>
      !((button.name?.trim() === '' || !button.name) &&
      (button.title?.trim() === '' || !button.title))).map(actionButton => ({
      name: actionButton.name,
      title: actionButton.title,
      icon: actionButton.icon,
      actions: actionButton.actions,
    })) || [];

    const actionButtonNames = new Set<string>();
    for (const actionButton of actionButtons) {
      const normalizedName = String(actionButton.name || '').trim().toLowerCase();
      if (actionButtonNames.has(normalizedName)) {
        this.toastr.error(`Action button name "${actionButton.name}" already exists. Please use a unique name.`);
        return null;
      }
      actionButtonNames.add(normalizedName);
      if (actionButton.actions.length === 0) {
        this.toastr.error('Please add at least one action for each action button');
        return null;
      }
      if (actionButton.name?.trim() === '' || actionButton.name === null) {
        this.toastr.error('Please enter name for all action buttons');
        return null;
      }
      if (actionButton.title?.trim() === '' || actionButton.title === null) {
        this.toastr.error('Please enter title for all action buttons');
        return null;
      }
      if (actionButton.actions.length === 0) {
        this.toastr.error('Please add at least one action for each action button');
        return null;
      }

      actionButton.actions = actionButton.actions.filter(action =>
        !((action.type?.trim() === '' || !action.type) &&
        (action.customField?.trim() === '' || !action.customField) &&
        (action.value?.trim() === '' || !action.value) &&
        (!action.settingKey || action.settingKey === '') &&
        (!action.campaignId) &&
        (!action.influencerTypeId) &&
        (!action.segmentId))
      ) || [];
      if (actionButton.actions.length === 0) {
        this.toastr.error('Please add at least one action for each action button');
        return null;
      }
      for (const action of actionButton.actions) {
        if (action.type === 'set_custom_field') {
          if (!this.campaignMeta.influencer_fields.some(field => field.key === action.customField && field.field_type === 'custom')) {
            if (action.value?.trim() !== '' && action.value !== null) {
              this.toastr.error(`Custom field "${action.customField}" does not exist`);
            }
            return null;
          }
          if (action.value?.trim() === '' || action.value === null) {
            if (action.customField !== null || action.undefined) {
              this.toastr.error('Please enter value for all actions of type "Custom Field"');
            }
            return null;
          }
        }
        if (action.type === 'set_campaign' && !action.campaignId) {
          this.toastr.error('Please select a campaign for all actions of type "Set Campaign"');
          return null;
        }
        if (action.type === 'set_segment' && (!action.influencerTypeId || !action.segmentId)) {
          this.toastr.error('Please select a category and a segment for all actions of type "Set Segment"');
          return null;
        }
        if (action.type === 'set_widget_settings') {
          if (!action.settingKey || action.settingKey === '') {
            this.toastr.error('Please select a setting for all actions of type "Set Widget Settings"');
            return null;
          }
          if (action.settingKey !== 'language' && (!action.value || String(action.value).trim() === '')) {
            this.toastr.error(this.isMetaMediaSetting(action.settingKey)
              ? 'Please select a file for all actions of type "Set Meta Media"'
              : 'Please enter a value for all actions of type "Set Widget Settings"');
            return null;
          }
        }
      }
    }

    return actionButtons;
  }

  async onSaveButtonClick() {
    if (!this.hasShareMedia()) {
      this.scrollAndHighlightImageButtons();
      return false;
    }
    if (!this.validateSocialMessage()) {
      this.changeToInvalidTab();
      return false;
    }
    this.onSave(() => {
      this.router.navigateByUrl('/' + routes.campaigns({ projectId: this.campaign.project_id }));
    });
  }

  personalizeImage() {
    this.router.navigate(['/projects', this.campaign.project_id, 'campaigns', this.campaign.id, 'personalize', 'social-image']);
  }

  /**
   * Personalize Video opens the share video's own design in the editor. The first time, while the
   * campaign has an image design, the video design starts as a copy of it (the server sets its
   * influencer image and campaign image to their video variables) and the share video uses it at
   * once. With neither design the editor starts a blank video design; its save puts it in use, as
   * it does for a video design kept after Remove Video.
   */
  async personalizeVideo(): Promise<void> {
    if (this.videoTemplateRequestPending) {
      return;
    }
    if (this.campaign?.social_video_template || !this.campaign?.social_template?.id) {
      this.openVideoEditor();
      return;
    }
    if (await this.copyImageDesignForVideo()) {
      this.openVideoEditor();
    }
  }

  private openVideoEditor() {
    this.router.navigate(['/projects', this.campaign.project_id, 'campaigns', this.campaign.id, 'personalize', 'social-video']);
  }

  /**
   * The design the share video renders from: always the campaign's own video design, while the
   * campaign uses it. There is no template video without one.
   */
  getShareVideoTemplate() {
    return this.campaignMeta?.video_template ? (this.campaign?.social_video_template || null) : null;
  }

  // Copies the image design into the video design, then puts it in use in one save. A share
  // message that save would refuse makes nothing. As with onSettingsChange, a selected share
  // preset no longer applies. True once saved.
  private async copyImageDesignForVideo(): Promise<boolean> {
    if (!this.validateSocialMessage()) {
      this.showShareMessageBlocksVideoDesign();
      return false;
    }
    this.videoTemplateRequestPending = true;
    try {
      if (!await this.ensureShareVideoTemplate()) {
        return false;
      }
      const previousPresetId = this.campaignMeta?.selected_campaign_share_preset_id;
      const preset = {id: this.selectedSharePresetId, item: this.selectedSharePreset};
      this.campaignMeta = {...this.campaignMeta, video_template: true};
      if (this.selectedSharePresetId) {
        this.clearSelectedSharePreset();
      }
      const status = await this.onSave();
      if (this.pageLeft) {
        return false;
      }
      if (status === 'saved') {
        return true;
      }
      // The video design exists by now, so the flag goes back as false, never unset: the campaign
      // read returns the design only once the flag is stored. Saved as a change of its own (the
      // autosave, else the leave guard or the page unload), so the next click opens this copy.
      this.campaignMeta = this.withMetaValues({
        video_template: false,
        selected_campaign_share_preset_id: previousPresetId
      });
      this.selectedSharePresetId = preset.id;
      this.selectedSharePreset = preset.item;
      if (preset.id) {
        this.keepSharePresetSelectionOnNextSettingsChange = true;
      }
      this.onSettingsChange(null, 0, false);
      if (status === 'invalid') {
        this.showShareMessageBlocksVideoDesign();
      } else {
        this.toastr.error('The video design could not be set up. Please try again.');
      }
      return false;
    } finally {
      this.videoTemplateRequestPending = false;
      this.cdr.markForCheck();
    }
  }

  // As Save and Next do: the tab whose message needs fixing comes up.
  private showShareMessageBlocksVideoDesign() {
    this.changeToInvalidTab();
    this.toastr.error('Fix the share message first: the video design was not set up.');
  }

  /**
   * Remove Video: the share video stops using the video design, which is kept for Personalize
   * Video to open again. No template video is left.
   */
  stopUsingVideoTemplate() {
    this.campaignMeta = {...this.campaignMeta, video_template: false};
    this.resetPreviewGeneration('video');
    this.onSettingsChange(null);
  }

  // The campaign's video design, made from the image's on first use.
  private async ensureShareVideoTemplate(): Promise<boolean> {
    if (this.campaign?.social_video_template) {
      return true;
    }
    try {
      const resp: any = await lastValueFrom(this.templateService.touch({
        campaign_id: this.campaign.id,
        template_type_id: VIDEO_TEMPLATE_TYPE_ID,
        source_template_id: this.campaign.social_template?.id,
        influencer_type_id: this.getCampaignSegment()?.influencer_type_id ?? null,
        name: `${this.campaign.id}-Personalized Share Video`
      }).pipe(takeUntil(this.unsubscriber)), { defaultValue: undefined });
      // Cut off by leaving the page: nothing to say and nothing to change.
      if (!resp) {
        return false;
      }
      if (!resp.success || !resp.data) {
        this.toastr.error(this.loaderService.getErrorMessage(resp));
        return false;
      }
      this.campaign = {...this.campaign, social_video_template: resp.data};
      return true;
    } catch (error) {
      this.toastr.error(this.loaderService.getErrorMessage(error));
      return false;
    }
  }

  // Sets these meta values back as they were; one that was not set is removed again.
  private withMetaValues(values: {[key: string]: any}) {
    const meta = {...this.campaignMeta};
    Object.entries(values).forEach(([key, value]) => {
      if (value === undefined) {
        delete meta[key];
      } else {
        meta[key] = value;
      }
    });
    return meta;
  }

  hasImageOrTemplate(): boolean {
    if (this.campaignMeta?.image_template && this.campaign?.social_template) {
      return true;
    }
    if (this.campaignMeta?.image) {
      return true;
    }
    return false;
  }

  /**
   * Something to share besides the text: the preview image, or a video alone (uploaded, or the
   * template video from the video design).
   */
  hasShareMedia(): boolean {
    return this.hasImageOrTemplate() || this.hasSelectedOrSavedVideo() || this.usesPersonalizeTemplateVideo();
  }

  /**
   * Shares no image, so the share can carry its video alone. The personalize template stops
   * being the share image but its design is kept: Personalize Image brings it back. The share
   * video has its own design, which this leaves alone.
   */
  removePreviewImage() {
    this.campaignMeta = {
      ...this.campaignMeta,
      image: '',
      image_width: null,
      image_height: null,
      image_template: false
    };
    this.onSettingsChange(null);
  }

  scrollAndHighlightImageButtons() {
    const imageButtonsDiv = this.imageButtonsDiv();
    if (imageButtonsDiv?.nativeElement) {
      imageButtonsDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const buttons = imageButtonsDiv.nativeElement.querySelectorAll('button');
      buttons.forEach((btn: HTMLElement) => btn.classList.add('highlight-flash'));
      setTimeout(() => {
        buttons.forEach((btn: HTMLElement) => btn.classList.remove('highlight-flash'));
      }, 3000);
    }
  }

  async onNextButtonClick() {
    if (!this.hasShareMedia()) {
      this.scrollAndHighlightImageButtons();
      return false;
    }
    if (!this.validateSocialMessage()) {
      this.changeToInvalidTab();
      return false;
    }

    this.onSave(() => {
      this.router.navigateByUrl(
        routes.campaignPreview({
          projectId: this.campaign.project_id,
          campaignId: this.campaign.id
        })
      );
    });
  }

  changeToInvalidTab() {
    this.currentSocialSharePlatforms.every(item => {
      if (this.isCampaignPageUrlRenderedForSocialNetwork(item) && !this.socialMessageKeepsCampaignPageUrl(item)) {
        this.currentSocialMediaPreviewing = item;
        return false;
      }
      return true;
    });
    // Also called by the leave guard, after its awaits.
    this.cdr.markForCheck();
  }

  getTitle() {
    if (this.socialMedias[this.currentSocialMediaPreviewing].hasOwnProperty('title') &&
      this.socialMedias[this.currentSocialMediaPreviewing]['title']) {
      return this.socialMedias[this.currentSocialMediaPreviewing]['title'];
    } else {
      return this.campaignMeta?.title;
    }
  }

  getImage() {
    this.contentType = 'image';
    let image = this.campaignMeta?.image;
    if (this.campaignMeta.hasOwnProperty('image_template') && this.campaignMeta.image_template) {
      image = this.campaign?.social_template?.thumbnail;
    }
    return image;
  }

  getVideoPreview() {
    return this.videoPreviewUrl || this.campaignMeta?.video;
  }

  /**
   * Whether the share video is produced from the video design rather than a file: the video
   * design is in use. Update Profile Video only lets an influencer upload the clip it composites,
   * as Update Profile Picture lets them upload their photo.
   */
  usesPersonalizeTemplateVideo() {
    return !!this.getShareVideoTemplate();
  }

  /**
   * The Preview Video: the video design rendered from sample values, as the Preview Image is
   * from the image design, so it shows before anybody has registered or recorded anything.
   */
  getGeneratedTemplateVideoUrl() {
    // The video design rendered with sample values and the sample clip, never any real
    // influencer's.
    return this.getShareVideoTemplate()?.share_video || '';
  }

  /**
   * With the personalize template in use an uploaded image does not replace it: the design shows
   * it, in the image bound to #CampaignMetaImageUrl#.
   */
  keepsTemplateForUploadedImage(): boolean {
    return !!(this.campaignMeta?.image_template && this.campaign?.social_template);
  }

  /**
   * The uploaded image, while the personalize template is the share image: one of its inputs.
   */
  getCampaignImageInput(): string {
    return this.campaignMeta?.image_template && this.campaign?.social_template
      ? (this.campaignMeta?.image || '')
      : '';
  }

  /**
   * The uploaded video, while the share video is generated from the video design: one of its
   * inputs.
   */
  getCampaignVideoInput(): string {
    return this.usesPersonalizeTemplateVideo() ? (this.getVideoPreview() || '') : '';
  }

  removeCampaignImage() {
    this.campaignMeta = {
      ...this.campaignMeta,
      image: '',
      image_width: null,
      image_height: null
    };
    this.onSettingsChange(null);
  }

  useUploadedImageInsteadOfTemplate() {
    this.campaignMeta = {...this.campaignMeta, image_template: false};
    this.onSettingsChange(null);
  }

  /**
   * Uploaded media the design does not use: the image only reaches the share image through an
   * image of the image design bound to #CampaignMetaImageUrl#, the video the share video through
   * an image of the video design bound to #CampaignMetaVideoUrl#.
   */
  getCampaignMediaUnusedWarning(kind: 'image' | 'video'): string | null {
    const uploaded = kind === 'image' ? this.getCampaignImageInput() : this.getCampaignVideoInput();
    const template = kind === 'image' ? this.campaign?.social_template : this.getShareVideoTemplate();
    if (!uploaded || template?.uses_campaign_media) {
      return null;
    }
    return kind === 'image'
      ? 'The design does not use this image. Bind an image of the design to #CampaignMetaImageUrl# '
        + 'to show it in the share image.'
      : 'The video design does not use this video. Bind an image of the video design to '
        + '#CampaignMetaVideoUrl# to play it there in the share video.';
  }

  /**
   * The share video's length, offered while it is generated from the video design with the
   * uploaded video in it.
   */
  showShareVideoLength(): boolean {
    return this.usesPersonalizeTemplateVideo() && this.hasSelectedOrSavedVideo();
  }

  getShareVideoLengthPlaceholder(): string {
    const seconds = Number(this.campaignMeta?.video_duration);
    return seconds > 0 ? String(Math.round(seconds * 10) / 10) : '';
  }

  setShareVideoDuration(value: any) {
    const seconds = value === null || value === undefined || value === '' ? null : Number(value);
    this.campaignMeta = {
      ...this.campaignMeta,
      share_video_duration: seconds !== null && Number.isFinite(seconds) && seconds > 0 ? seconds : null
    };
    this.onSettingsChange(null);
  }

  /**
   * A preview video takes its own shape once its metadata is known; the stored size is only the
   * placeholder's.
   */
  onPreviewVideoMetadata(src: string, event: Event) {
    const video = event?.target as HTMLVideoElement;
    if (src && video?.videoWidth && video?.videoHeight) {
      this.previewVideoShapes[src] = `${video.videoWidth} / ${video.videoHeight}`;
      this.cdr.markForCheck();
    }
  }

  getPreviewVideoAspectRatio(src: string, placeholder: string): string {
    return (src && this.previewVideoShapes[src]) || placeholder;
  }

  getFallbackImage() {
    if (this.campaignMeta.hasOwnProperty('image_template') && this.campaignMeta.image_template) {
      return this.campaign?.social_template?.thumbnail;
    }
    return this.campaignMeta?.image;
  }

  getVideoPoster() {
    return this.videoPosterPreviewUrl || this.campaignMeta?.video_poster || '';
  }

  getPreviewMediaState(kind: 'image' | 'video', src: string): 'loading' | 'loaded' | 'error' {
    const load = this.previewMediaLoad[kind];
    return load && load.src === src ? load.state : 'loading';
  }

  onPreviewMediaLoaded(kind: 'image' | 'video', src: string) {
    if (this.getPreviewMediaState(kind, src) !== 'loaded') {
      this.previewMediaLoad = {...this.previewMediaLoad, [kind]: {src, state: 'loaded'}};
    }
  }

  onPreviewMediaError(kind: 'image' | 'video', src: string) {
    this.previewMediaLoad = {...this.previewMediaLoad, [kind]: {src, state: 'error'}};
  }

  /**
   * The Preview Image is the template's thumbnail and is being rendered: there is none yet, or it
   * is of older content than the template now has, and the template was saved recently - a save
   * is what asks for the render. A thumbnail that went stale long ago is not being rendered, so it
   * is shown as it is (or the empty state) instead of a spinner. It arrives by socket
   * (requesterType template).
   */
  isPreviewImageGenerating(): boolean {
    const template = this.campaign?.social_template;
    if (!this.campaignMeta?.image_template || !template?.id) {
      return false;
    }
    const stale = !template.thumbnail || (!!template.thumbnail_content_hash && !!template.content_hash &&
      template.thumbnail_content_hash !== template.content_hash);
    const savedAt = Date.parse(template.updated_at);
    const savedRecently = Number.isFinite(savedAt) && Date.now() - savedAt < this.previewGenerationTimeoutMs;
    return stale && savedRecently && !this.hasPreviewGenerationTimedOut('image', template);
  }

  /**
   * Where the generated Preview Video stands. share_video_content_hash says which content the
   * server last made a video for; every content gets one - a still of the design when the
   * template has no image set to a video variable. Anything else is a render the server has been
   * asked for (on the template save, or on the campaign read and save once the campaign offers
   * video), waited on for a while. That includes a template recorded with no video, as one
   * without such an image used to be: the server makes it one now.
   */
  getTemplateVideoPreviewStatus(): 'ready' | 'generating' | 'delayed' {
    const template = this.getShareVideoTemplate() || {};
    const current = !!template.content_hash && template.share_video_content_hash === template.content_hash;
    if (template.share_video && (current || !template.content_hash)) {
      return 'ready';
    }
    if (!this.hasPreviewGenerationTimedOut('video', template)) {
      return 'generating';
    }
    return template.share_video ? 'ready' : 'delayed';
  }

  /**
   * Why the Preview Video shows the design without a clip, said under it. It never holds the
   * video back: a template needs no image set to a video variable for its share video to exist.
   */
  getTemplateVideoPreviewWarning(): string {
    const warning = this.getShareVideoTemplate()?.share_video_warning;
    if (!warning || this.getTemplateVideoPreviewStatus() !== 'ready') {
      return '';
    }
    if (warning === 'no_clip') {
      return 'The video slot in this video design has no clip to play, so the Preview Video shows the '
        + 'design without one.';
    }
    return 'This video design has no image set to a video variable (Influencer Video URL, Influencer '
      + 'Video or a Video Recorder custom field), so the Preview Video shows the design without a clip.';
  }

  getTemplateVideoAspectRatio() {
    return this.getTemplateAspectRatio(this.getShareVideoTemplate());
  }

  getPreviewImageAspectRatio() {
    return this.getTemplateAspectRatio(this.campaign?.social_template);
  }

  private getTemplateAspectRatio(template: any) {
    const width = Number(template?.width);
    const height = Number(template?.height);
    return width && height ? `${width} / ${height}` : this.getVideoAspectRatio();
  }

  // The first ask starts the clock for this template content; after the timeout the spinner
  // gives way to a "taking longer" note, and a late socket message still shows the result.
  private hasPreviewGenerationTimedOut(kind: 'image' | 'video', template: any): boolean {
    const key = `${kind}:${template?.id}:${template?.content_hash || ''}`;
    if (this.previewGenerationTimedOut.has(key)) {
      return true;
    }
    if (!this.previewGenerationTimers.has(key)) {
      this.previewGenerationTimers.set(key, setTimeout(() => {
        this.previewGenerationTimedOut.add(key);
        this.cdr.markForCheck();
      }, this.previewGenerationTimeoutMs));
    }
    return false;
  }

  resetPreviewGeneration(kind: 'image' | 'video') {
    for (const [key, timer] of this.previewGenerationTimers) {
      if (key.startsWith(kind + ':')) {
        clearTimeout(timer);
        this.previewGenerationTimers.delete(key);
      }
    }
    for (const key of Array.from(this.previewGenerationTimedOut)) {
      if (key.startsWith(kind + ':')) {
        this.previewGenerationTimedOut.delete(key);
      }
    }
  }

  getVideoAspectRatio() {
    const width = Number(this.campaignMeta?.video_width);
    const height = Number(this.campaignMeta?.video_height);
    return width && height ? `${width} / ${height}` : '16 / 9';
  }

  hasVideoPoster() {
    return !!(this.videoPosterPreviewUrl || this.campaignMeta?.video_poster);
  }

  hasSelectedOrSavedVideo() {
    return !!(this.pendingMediaUploads.video || this.videoPreviewUrl || this.campaignMeta?.video);
  }

  onVideoUploadEnabledChange(event) {
    this.videoUploadEnabled = event?.target?.checked;
    if (!this.videoUploadEnabled) {
      this.videoPreviewUrl = '';
      this.videoPosterPreviewUrl = '';
      this.pendingMediaUploads.video = null;
      this.pendingMediaUploads.video_poster = null;
      this.campaignMeta = {
        ...this.campaignMeta,
        video: '',
        video_poster: '',
        video_validation: null
      };
      if (this.uploadMediaType === 'video' || this.uploadMediaType === 'video_poster') {
        this.contentFile = null;
        this.contentSignedUrl = null;
        this.isVideoUploaded = false;
        this.uploadMediaType = 'image';
      }
      this.onSettingsChange(null);
    }
  }

  removeVideoPoster() {
    this.videoPosterPreviewUrl = '';
    this.contentFile = null;
    this.contentSignedUrl = null;
    this.pendingMediaUploads.video_poster = null;
    this.uploadMediaType = 'image';
    this.campaignMeta = {
      ...this.campaignMeta,
      video_poster: ''
    };
    this.onSettingsChange(null);
  }

  removeVideo() {
    this.videoUploadEnabled = false;
    this.videoPreviewUrl = '';
    this.videoPosterPreviewUrl = '';
    this.contentFile = null;
    this.contentSignedUrl = null;
    this.isVideoUploaded = false;
    this.validatedVideoInfo = null;
    this.pendingMediaUploads.video = null;
    this.pendingMediaUploads.video_poster = null;
    this.uploadMediaType = 'image';
    this.campaignMeta = {
      ...this.campaignMeta,
      video: '',
      video_width: '',
      video_height: '',
      video_duration: '',
      video_frame_rate: '',
      video_size: '',
      video_mime_type: '',
      video_poster: '',
      video_validation: null,
      share_video_duration: null
    };
    this.onSettingsChange(null);
  }

  getVideoValidationErrorText() {
    return this.campaignMeta?.video_validation?.errors?.join(', ') || '';
  }

  getImageWidth() {
    if (this.campaignMeta.hasOwnProperty('image_template') && this.campaignMeta.image_template) {
      return this.campaign?.social_template?.width;
    } else {
      return this.campaignMeta.hasOwnProperty('image_width') ? this.campaignMeta.image_width : 500;
    }
  }

  getDescription() {
    return this.campaignMeta?.description;
  }

  getMessage() {
    if (this.socialMedias[this.currentSocialMediaPreviewing].hasOwnProperty('message') &&
      this.socialMedias[this.currentSocialMediaPreviewing]['message']) {
      return this.socialMedias[this.currentSocialMediaPreviewing]['message'];
    }
    return '';
  }

  applyToOthers() {
    const patchData = this.socialMedias[this.currentSocialMediaPreviewing];
    this.socialMedias = {
      ...this.socialMedias,
      facebook: {
        ...this.socialMedias.facebook,
        ...patchData
      },
      linkedin: {
        ...this.socialMedias.linkedin,
        ...patchData
      },
      twitter: {
        ...this.socialMedias.twitter,
        ...patchData
      },
      whatsapp: {
        ...this.socialMedias.whatsapp,
        ...patchData
      },
      slack: {
        ...this.socialMedias.slack,
        ...patchData
      },
      instagram: {
        ...this.socialMedias.instagram,
        ...patchData
      },
      email: {
        ...this.socialMedias.email,
        ...patchData
      },
      facebook_messenger: {
        ...this.socialMedias.facebook_messenger,
        ...patchData
      },
      microsoft_teams: {
        ...this.socialMedias.microsoft_teams,
        ...patchData
      },
      sms: {
        ...this.socialMedias.sms,
        ...patchData
      },
      zalo: {
        ...this.socialMedias.zalo,
        ...patchData
      },
      line: {
        ...this.socialMedias.line,
        ...patchData
      },
      wechat: {
        ...this.socialMedias.wechat,
        ...patchData
      },
      bluesky: {
        ...this.socialMedias.bluesky,
        ...patchData
      },
      telegram: {
        ...this.socialMedias.telegram,
        ...patchData
      },
      vk: {
        ...this.socialMedias.vk,
        ...patchData
      },
      viber: {
        ...this.socialMedias.viber,
        ...patchData
      },
      signal: {
        ...this.socialMedias.signal,
        ...patchData
      },
      tiktok: {
        ...this.socialMedias.tiktok,
        ...patchData
      }
    };
    this.validateSocialMessage();
    this.onSettingsChange(null, 2, false);
  }

  autoGrow(element) {
    element.style.height = '5px';
    element.style.height = (element.scrollHeight + 10) + 'px';
  }

  changeSocialMediaPreview(socialMedia) {
    this.currentSocialMediaPreviewing = socialMedia;
    this.cdr.markForCheck();
    setTimeout(() => {
      const title = this.title();
      if (title) {
        this.autoGrow(title.nativeElement);
      }
      if (this.message()) {
        this.autoGrow(this.message().nativeElement);
      }
      if (this.description()) {
        this.autoGrow(this.description().nativeElement);
      }
    }, 200);

    if (this.alreadyVisitedTabs.indexOf(socialMedia) === -1) {
      this.message().nativeElement.addEventListener('keypress', (ev) => {
        this.socialShareSkip = localStorage.getItem('skip');
        this.socialShareInfo = true;
        this.alreadyVisitedTabs.push(socialMedia);
        this.cdr.markForCheck();
      }, { once: true });
    }
  }

  onSkip() {
    localStorage.setItem('skip' , 'true');
    this.socialShareInfo = false;
  }

  async previewSocialShare() {
    if (!this.validateSocialMessage()) {
      this.changeToInvalidTab();
      return false;
    }
    this.previewClicked = true;
    this.onSave();
  }

  async previewGenericSocialShare() {
    if (!this.validateSocialMessage()) {
      this.changeToInvalidTab();
      return false;
    }
    this.previewGenericClicked = true;
    this.onSave();
  }

  ngOnDestroy() {
    this.pageLeft = true;
    this.resetPreviewGeneration('image');
    this.resetPreviewGeneration('video');
    this.removePreviewIframeClickHandler();
    window.removeEventListener('message', this.videoRecorderMessageHandler);
    window.removeEventListener('message', this.handleFontBrowserMessage);
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    this.setVideoRecorderPageMode(false);
    // Fire whatever save is still pending (the leave guard normally already flushed it).
    // pendingActionVideoUploads is only cleared once the queue has drained, so an
    // in-flight upload isn't dropped out from under it.
    this.flushPendingSave().finally(() => this.pendingActionVideoUploads.clear());
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
    this.subscription.unsubscribe();
    this.templateGeneratorService.unsubscribe();
  }

  async cropImage(file: File, cropConfig = null): Promise<File | boolean> {
    return new Promise((resolve, reject) => {
      //
      // Set element and file reader
      const reader = new FileReader();

      //
      // On load
      reader.onloadend = (e) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          width: '700px',
          data: {
            file: reader.result,
            filename: file.name,
            cropConfig: {
              aspectRatio: cropConfig?.aspectRatio ?? this.aspectRatio,
              portrait: cropConfig?.portrait ?? this.portrait,
              landscape: cropConfig?.landscape ?? this.landscape
            }
          }
        });

        dialogRef.afterClosed().subscribe((data) => {
          //
          // Validate
          if (!data || data.success !== true) {
            return resolve(false);
          }

          return resolve(data.file);
        });
      };

      //
      // Read file
      reader.readAsDataURL(file);
    });
  }

  applyRTLEmbedding(element = null, textFor, currentSocialMediaPreviewing = '') {
    if (element) {
      const cursorPosition = element.selectionStart;
      const inputText = element.value;
      const convertedText = inputText.slice(0, cursorPosition) + '\u202B' + inputText.slice(cursorPosition);
      if (textFor === 'social') {
        this.socialMedias[currentSocialMediaPreviewing]['message'] = convertedText;
      } else {
        this.campaignMeta[textFor] = convertedText;
      }
      element.value = convertedText;

      this.onSettingsChange(null, 2, false);
    }
  }

  showCustomizeAvatarTemplatePopup() {
    this.cdr.detectChanges();
    const data = {
      project_id: this.campaign.project_id
    };
    const modelRef = this.sbModal.openComponent(WidgetAvatarTemplatesComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    }, {
      data,
    });
    modelRef.result.then((result) => {
    }, (reason) => {
      this.fetchWidgetAITemplates();
    });
  }

  fetchWidgetAITemplates() {
    const orderBy = {column: 'created_at', dir: 'desc'};
    const options = {orderBy};
    setTimeout(() => {
      this.templateStore.dispatch(WidgetAvatarTemplateListAll({
        params: {
          options: JSON.stringify(options),
          project_id: this.campaign.project_id
        }
      }));
    }, 500);
  }

  selectWidgetAIAvatarTemplate(id) {
    this.campaignMeta['widget_ai_avatar_template'] = id;
    this.selectedWidgetAIAvatarTemplate = this.widgetAIAvatarTemplates.find((item) => item.id === id) || null;
    this.onSettingsChange(null);
  }

  getCampaignWidgetGlobalValueLabel(key: string) {
    return this.coerceWidgetBoolean(this.getCampaignWidgetGlobalValue(key)) ? 'ON' : 'OFF';
  }

  isCampaignWidgetUsingGlobal(key: string) {
    const setting = this.campaignWidgetOverrideSettings.find(item => item.key === key);
    if (!setting) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(this.campaignMeta || {}, setting.useGlobalKey)) {
      return setting.valueType === 'boolean'
        ? typeof this.campaignMeta?.[key] !== 'boolean'
        : this.campaignMeta?.[key] == null;
    }
    return this.coerceWidgetBoolean(this.campaignMeta?.[setting.useGlobalKey]);
  }

  // A text setting the campaign never filled in (null, not '') renders the project's value on
  // the server, so show it as inherited. The auto-save that introduced these flags stored false.
  private inheritUnsetCampaignWidgetFields() {
    for (const setting of this.campaignWidgetOverrideSettings) {
      if (setting.valueType === 'value' && this.campaignMeta[setting.key] == null) {
        this.campaignMeta[setting.useGlobalKey] = true;
      }
    }
  }

  // A text the campaign cleared ('', Use Global off) does not fall back to the project's, only to the
  // built-in one.
  getWidgetHeaderPlaceholder(key: string) {
    const inherits = this.isCampaignWidgetUsingGlobal(key) || this.campaignMeta?.[key] == null;
    return widgetHeaderPlaceholder(this.widgetHeaderKey(key), inherits ? this.getCampaignWidgetGlobalValue(key) : null);
  }

  getWidgetHeaderNotLiveNote(key: string) {
    if (!this.isCampaignWidgetUsingGlobal(key) || !this.campaignMeta?.[key]) {
      return null;
    }
    return widgetHeaderNotLiveNote(this.widgetHeaderKey(key), this.getCampaignWidgetGlobalValue(key));
  }

  private widgetHeaderKey(key: string) {
    return key.replace('widget_', '') as WidgetHeaderKey;
  }

  getCampaignWidgetGlobalValue(key: string) {
    if (key === 'allow_influencers_to_use_ai_avatar_in_widget') {
      return !!this.widget_Settings?.['allow_influencers_to_update_their_picture_in_widget'] &&
        !!this.widget_Settings?.['allow_influencers_to_use_ai_avatar_in_widget'];
    }
    const setting = this.campaignWidgetOverrideSettings.find(item => item.key === key);
    return this.widget_Settings?.[setting?.globalKey || key];
  }

  getCampaignWidgetSettingValue(key: string) {
    const value = this.isCampaignWidgetUsingGlobal(key)
      ? this.coerceWidgetBoolean(this.getCampaignWidgetGlobalValue(key))
      : this.coerceWidgetBoolean(this.campaignMeta?.[key]);

    if (key === 'allow_influencers_to_use_ai_avatar_in_widget') {
      return this.getCampaignWidgetSettingValue('allow_influencers_to_update_their_picture_in_widget') && value;
    }
    return value;
  }

  getCampaignWidgetFieldValue(key: string) {
    if (this.campaignWidgetOwnTextKeys.includes(key)) {
      return this.campaignMeta?.[key];
    }
    return this.isCampaignWidgetUsingGlobal(key)
      ? this.getCampaignWidgetGlobalValue(key)
      : this.campaignMeta?.[key];
  }

  onCampaignWidgetFieldChange(key: string, value: any) {
    if (this.isCampaignWidgetUsingGlobal(key)) {
      return;
    }
    this.campaignMeta[key] = value ?? null;
    this.onSettingsChange(value);
  }

  private coerceWidgetBoolean(value: any) {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'number') {
      return value !== 0;
    }
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      if (['true', '1', 'on', 'yes'].includes(normalized)) {
        return true;
      }
      if (['false', '0', 'off', 'no', 'null', 'undefined', ''].includes(normalized)) {
        return false;
      }
    }
    return !!value;
  }

  setCampaignWidgetSettingValue(key: string, value: boolean) {
    this.campaignMeta[key] = value;
    if (key === 'allow_influencers_to_update_their_picture_in_widget' && !value) {
      this.campaignMeta['allow_influencers_to_use_ai_avatar_in_widget'] = false;
    }
    if (key === 'allow_influencers_to_update_their_picture_in_widget') {
      this.syncInfluencerPictureFieldEnabledWithWidgetSetting();
    }
    if (key === 'allow_influencers_to_update_their_video_in_widget') {
      this.syncInfluencerVideoFieldEnabledWithWidgetSetting();
    }
    this.onSettingsChange(value);
  }

  onCampaignWidgetUseGlobalChange(key: string, useGlobal: boolean) {
    const setting = this.campaignWidgetOverrideSettings.find(item => item.key === key);
    if (!setting) {
      return;
    }
    this.campaignMeta[setting.useGlobalKey] = useGlobal;
    if (!useGlobal && setting.valueType === 'boolean') {
      this.campaignMeta[key] = this.coerceWidgetBoolean(this.getCampaignWidgetGlobalValue(key));
    }
    if (setting.valueType === 'value') {
      if (!useGlobal && !this.campaignWidgetOwnTextKeys.includes(key) && this.campaignMeta[key] == null) {
        this.campaignMeta[key] = this.getCampaignWidgetGlobalValue(key) ?? null;
      }
      this.cdr.markForCheck();
    }
    if (key === 'allow_influencers_to_update_their_picture_in_widget') {
      this.syncInfluencerPictureFieldEnabledWithWidgetSetting();
    }
    if (key === 'allow_influencers_to_update_their_video_in_widget') {
      this.syncInfluencerVideoFieldEnabledWithWidgetSetting();
    }
    this.onSettingsChange(useGlobal);
  }

  // setInactive(positionId) {
  //   // const positionIndex = this.positions.findIndex((icon) => icon.id === positionId);
  //   // if (positionIndex !== -1) {
  //   //   const [position] = this.positions.splice(positionIndex, 1); // Remove the element from its current position
  //   //   position.active = false; // Mark it as inactive
  //   //   this.positions.push(position); // Add it to the end of the array
  //   //   this.rearrangePositions();
  //   // }
  //   const position = this.positions.find((icon) => icon.id === positionId);
  //   if (position) {
  //     position.active = false; // Mark as inactive
  //   }
  // }
  //
  // rearrangePositions() {
  //   const activePositions = this.positions.filter((pos) => pos.active);
  //   activePositions.forEach((position, index) => {
  //     position.x = ((index % this.columns) * 30) + 10; // 160 is spacing for each column
  //     position.y = Math.floor(index / this.columns) * 30; // 100 is spacing for each row
  //   });
  //   console.log(this.positions)
  // }

  onMovingSocialNetworkItems(event, currentBox) {
    // if (!currentBox.active) return;
    const currentPosition = this.positions.find(
      (pos) => pos.id === currentBox.id
    );

    for (const position of this.positions) {
      if (position.id !== currentBox.id) {
        const withinXRange =
          event.x + this.boxWidth / 2 >= position.x &&
          event.x + this.boxWidth / 2 <= position.x + this.boxWidth;
        const withinYRange =
          event.y + this.boxHeight / 2 >= position.y &&
          event.y + this.boxHeight / 2 <= position.y + this.boxHeight;

        // Swap positions
        if (withinXRange && withinYRange) {
          const temp = { x: position.x, y: position.y, order: position.order };
          position.x = currentPosition.x;
          position.y = currentPosition.y;
          position.order = currentPosition.order;
          currentPosition.x = temp.x;
          currentPosition.y = temp.y;
          currentPosition.order = temp.order;
          break;
        }
      }
    }
  }

  getUsedCustomFields(button): string[] {
    return button.actions
      .filter(a => a.type === 'set_custom_field')
      .map(a => a.customField)
      .filter(Boolean);
  }

  addActionButton(afterIndex: number) {
    this.campaignMeta.action_buttons.splice(afterIndex + 1, 0, {
      name: '',
      title: '',
      icon: null,
      actions: [
        { type: '' }
      ]
    });
  }

  removeActionButton(index: number) {
    for (const action of this.campaignMeta.action_buttons[index]?.actions || []) {
      this.clearPendingActionVideoUpload(action);
    }
    this.campaignMeta.action_buttons.splice(index, 1);
    if (this.campaignMeta.default_action_button_index >= this.campaignMeta.action_buttons.length) {
      this.campaignMeta.default_action_button_index = 0;
    }
    this.onSettingsChange(null);
  }

  addAction(button, index: number) {
    button.actions.splice(index + 1, 0, { type: '', value: null, widget_settings: null });
  }

  onActionTypeChange(action, button, editorType) {
    this.clearPendingActionVideoUpload(action);
    action.value = null;
    delete action.valueEditorMode;
    this.clearActionVideoMetadata(action);
    action.type = editorType === 'set_meta_media' ? 'set_widget_settings' : editorType;
    if (editorType === 'set_meta_media') {
      const usedSettingKeys = button.actions
        .filter((item) => item !== action && this.isMetaMediaSetting(item.settingKey))
        .map((item) => item.settingKey);
      action.settingKey = this.metaMediaSettingKeys.find((setting) => !usedSettingKeys.includes(setting.key))?.key || '';
      delete action.widget_settings;
    } else if (editorType === 'set_widget_settings') {
      action.settingKey = '';
      action.widget_settings = null;
    } else {
      delete action.settingKey;
      delete action.widget_settings;
    }
  }

  removeAction(button, index: number) {
    this.clearPendingActionVideoUpload(button.actions[index]);
    button.actions.splice(index, 1);
    this.onSettingsChange(null);
  }

  isActionTypeAdded(button, type: string): boolean {
    return button.actions.some(a => a.type === type);
  }

  readonly widgetSettingKeys = [
    { key: 'language', label: 'Language' },
    { key: 'header_1', label: 'Header 1' },
    { key: 'header_2', label: 'Header 2' },
    { key: 'header_3', label: 'Header 3' },
    { key: 'custom_minimized_text', label: 'Custom Minimized Text' },
    { key: 'promo_text', label: 'Promo Text' }
  ];

  readonly metaMediaSettingKeys = [
    { key: 'meta_image', label: 'Meta Image' },
    { key: 'meta_video', label: 'Meta Video' },
    { key: 'meta_video_cover', label: 'Meta Cover' }
  ];

  readonly actionVideoMetadataFields = [
    'video_validation',
    'video_width',
    'video_height',
    'video_duration',
    'video_frame_rate',
    'video_size',
    'video_mime_type'
  ];

  isMetaMediaSetting(settingKey: string): boolean {
    return this.metaMediaSettingKeys.some((setting) => setting.key === settingKey);
  }

  getActionEditorType(action): string {
    return action.type === 'set_widget_settings' && this.isMetaMediaSetting(action.settingKey)
      ? 'set_meta_media'
      : action.type;
  }

  onWidgetSettingKeyChange(action) {
    action.value = null;
    delete action.valueEditorMode;
    this.onSettingsChange(null);
  }

  onMetaMediaSettingKeyChange(action) {
    this.clearPendingActionVideoUpload(action);
    action.value = null;
    this.clearActionVideoMetadata(action);
    this.onSettingsChange(null);
  }

  async onMetaMediaActionValueSelected(value: string | null, action) {
    try {
      await this.selectMetaMediaActionValue(value, action);
    } finally {
      this.cdr.markForCheck();
    }
  }

  private async selectMetaMediaActionValue(value: string | null, action) {
    if (!value || action.settingKey !== 'meta_video') {
      this.clearPendingActionVideoUpload(action);
      action.value = value;
      this.clearActionVideoMetadata(action);
      this.onSettingsChange(null);
      return;
    }

    if (!/\.mp4(?:[?#]|$)/i.test(value)) {
      this.toastr.error('Only MP4 video files are allowed');
      return;
    }

    this.loaderService.show();
    try {
      const response = await fetch(this.getFileBrowserDownloadUrl(value));
      if (!response.ok) {
        throw new Error(`Unable to download selected video (${response.status})`);
      }
      const sourceBlob = await response.blob();
      let fileName = 'meta-video.mp4';
      try {
        fileName = decodeURIComponent(
          new URL(value, `${environment.apiUrl}/`).pathname.split('/').pop()
        ) || fileName;
      } catch (_) {
        fileName = 'meta-video.mp4';
      }
      const uploadFile = new File([sourceBlob], fileName, {type: 'video/mp4'});
      if (!await this.validateVideo(uploadFile, 'mp4')) {
        this.loaderService.hide(true);
        return;
      }

      this.pendingActionVideoUploads.set(action, uploadFile);
      action.value = value;
      this.clearActionVideoMetadata(action);
      this.loaderService.hide();
      this.onSettingsChange(null);
    } catch (error) {
      this.loaderService.hide(true);
      this.toastr.error('Unable to prepare the selected MP4 video. Please try again.');
    }
  }

  private clearPendingActionVideoUpload(action) {
    this.pendingActionVideoUploads.delete(action);
  }

  private getFileBrowserDownloadUrl(value: string): string {
    try {
      const url = new URL(value, `${environment.apiUrl}/`);
      const pathParts = url.pathname.split('/').filter(Boolean);
      if (/^s3[.-]/i.test(url.hostname) && url.hostname.endsWith('amazonaws.com')) {
        pathParts.shift();
      } else if (pathParts[0] === 's3') {
        pathParts.shift();
      }
      const key = pathParts.map((part) => encodeURIComponent(decodeURIComponent(part))).join('/');
      return `${environment.apiUrl}/s3/${key}`;
    } catch (_) {
      return value;
    }
  }

  clearActionVideoMetadata(action) {
    for (const field of this.actionVideoMetadataFields) {
      delete action[field];
    }
  }

  getUsedWidgetSettingKeys(button): string[] {
    return button.actions.filter(a => a.type === 'set_widget_settings' && a.settingKey && a.settingKey !== '').map(a => a.settingKey);
  }

  getUsedMetaMediaSettingKeys(button): string[] {
    return button.actions.filter(a => this.isMetaMediaSetting(a.settingKey)).map(a => a.settingKey);
  }

  removeActionButtonIcon(buttonIndex) {
    const button = this.campaignMeta.action_buttons[buttonIndex];
    button.iconData = null;
    button.iconFile = null;
    button.iconSignedUrl = null;
    button.icon = null;

    this.onSettingsChange(null);
  }

  getCampaigns(page = 0, perPage = 1000, search = '', orderBy = {column: 'name', dir: 'asc'}) {
    this.campaignStore.dispatch(CampaignGetAllPaginate({
      params: {
        project_id: this.campaign?.project_id,
        // Only the "set campaign" action's picker reads this list (id and name), so no email or
        // contact stats: those cost a grouped count per page on the server.
        options: JSON.stringify({include_project: true, include_segments: true, include_template: true, includePagination: true,
          orderBy}),
        page: page + 1,
        perPage,
        search
      }
    }));
  }

  getInfluencerTypeSegments(influencerTypeId) {
    if (!influencerTypeId) {
      return [];
    }
    return this.segmentsGlobal.filter(segment => segment.influencer_type_id === parseInt(influencerTypeId, 10));
  }

  getEnabledCustomFields() {
    return this.campaignMeta.influencer_fields.filter(field => this.getInfluencerFieldEnabled(field)).map(field => field.key);
  }

  getCustomField(key) {
    return this.campaignMeta.influencer_fields.find(field => field.key === key);
  }

  createDefaultSystemInfluencerFields() {
    return [
      { key: 'influencer_picture', label: 'Headshot/logo', enabled: true, title: 'Headshot/logo', type: 'image', field_type: 'system', read_only: false, required: false },
      { key: 'influencer_video', label: 'Video', enabled: true, title: 'Video', type: 'video-recorder', field_type: 'system', read_only: false, required: false }
    ].map(field => this.normalizeInfluencerField(field));
  }

  createDefaultPrimaryInfluencerFields() {
    return [
      { key: 'prefix', label: 'Prefix', enabled: true, title: 'Prefix', type: 'text', field_type: 'primary', read_only: false },
      { key: 'first_name', label: 'First Name', enabled: true, title: 'First Name', type: 'text', field_type: 'primary', read_only: false },
      { key: 'last_name', label: 'Last Name', enabled: true, title: 'Last Name', type: 'text', field_type: 'primary', read_only: false },
      { key: 'suffix', label: 'Suffix', enabled: true, title: 'Suffix', type: 'text', field_type: 'primary', read_only: false },
      { key: 'email', label: 'Email', enabled: true, title: 'Email', type: 'text', field_type: 'primary', read_only: false },
      { key: 'company', label: 'Company', enabled: true, title: 'Company', type: 'text', field_type: 'primary', read_only: false },
      { key: 'booth_number', label: 'Booth Number', enabled: true, title: 'Booth Number', type: 'text', field_type: 'primary', read_only: false },
      { key: 'job_title', label: 'Job Title', enabled: true, title: 'Job Title', type: 'text', field_type: 'primary', read_only: false },
    ].map(field => this.normalizeInfluencerField(field));
  }

  createDefaultCustomInfluencerFields() {
    return [
      { key: 'custom_message', label: 'Custom Message', enabled: false, title: '', type: 'text', defaultValue: '', required: false, default_fallback: false, read_only: false, field_type: 'custom' },
      ...Array.from({ length: 10 }, (_, i) => ({
        key: `custom_${i + 1}`,
        label: `Custom ${i + 1}`,
        enabled: false,
        title: '',
        type: 'text',
        defaultValue: '',
        required: false,
        default_fallback: false,
        read_only: false,
        field_type: 'custom'
      }))
    ].map(field => this.normalizeInfluencerField(field));
  }

  createDefaultInfluencerFields() {
    return [
      ...this.createDefaultSystemInfluencerFields(),
      ...this.createDefaultPrimaryInfluencerFields(),
      ...this.createDefaultCustomInfluencerFields()
    ];
  }

  normalizeInfluencerField(field) {
    const isPrimaryField = field.field_type === 'primary';
    const isInfluencerPictureField = field.key === 'influencer_picture';
    const isVideoField = field.key === 'influencer_video' || field.key === 'video_url';
    const fallbackTitle = isPrimaryField ? field.label : field.title;
    const normalizedTitle = isVideoField
      ? ((field.title || '').trim() || field.label || 'Video')
      : (isPrimaryField || isInfluencerPictureField) && !field.title?.trim()
        ? (field.label || 'Headshot/logo')
        : field.title;

    const normalizedField = {
      ...field,
      label: field.key === 'influencer_picture'
        ? 'Headshot/logo'
        : isVideoField ? 'Video' : field.label,
      type: field.key === 'influencer_picture'
        ? 'image'
        : isVideoField ? 'video-recorder' : field.type,
      title: field.key === 'influencer_picture'
        ? (normalizedTitle ?? 'Headshot/logo')
        : (normalizedTitle ?? fallbackTitle ?? ''),
      key: field.key === 'video_url' ? 'influencer_video' : field.key,
      field_type: field.key === 'influencer_picture' || isVideoField ? 'system' : field.field_type,
      read_only: field.read_only ?? false,
      required: field.required ?? false,
      defaultValue: this.normalizeCustomFieldDefaultValue(field),
      tab: field.tab ?? '',
      group: field.group ?? ''
    };

    if (normalizedField.field_type === 'custom' && normalizedField.type === 'video-recorder') {
      normalizedField.video_settings = this.normalizeInfluencerFieldVideoSettings(normalizedField.video_settings);
    } else if (Object.prototype.hasOwnProperty.call(normalizedField, 'video_settings')) {
      delete normalizedField.video_settings;
    }
    if (normalizedField.field_type === 'custom' && normalizedField.type === 'image') {
      normalizedField.image_settings = this.normalizeInfluencerFieldImageSettings(normalizedField.image_settings);
    } else if (Object.prototype.hasOwnProperty.call(normalizedField, 'image_settings')) {
      delete normalizedField.image_settings;
    }

    return normalizedField;
  }

  normalizeInfluencerFields(fields) {
    const hasSystemVideo = (fields || []).some(field => field.key === 'influencer_video');
    let normalizedFields = _.uniqBy(
      (fields || [])
        .filter(field => !hasSystemVideo || field.key !== 'video_url')
        .map(field => this.normalizeInfluencerField(field)),
      'key'
    );
    if (!normalizedFields.some(field => field.key === 'influencer_picture')) {
      normalizedFields = [
        this.createDefaultSystemInfluencerFields().find(field => field.key === 'influencer_picture'),
        ...normalizedFields
      ];
    }

    if (!normalizedFields.some(field => this.isInfluencerVideoField(field))) {
      const videoField = this.createDefaultSystemInfluencerFields().find(field => field.key === 'influencer_video');
      if (!videoField) {
        return normalizedFields;
      }
      const headshotIndex = normalizedFields.findIndex(field => field.key === 'influencer_picture');
      if (headshotIndex === -1) {
        normalizedFields = [...normalizedFields, videoField];
      } else {
        normalizedFields = [
          ...normalizedFields.slice(0, headshotIndex + 1),
          videoField,
          ...normalizedFields.slice(headshotIndex + 1)
        ];
      }
    }
    return normalizedFields;
  }

  isInfluencerPictureField(field) {
    return field?.key === 'influencer_picture' && field?.field_type === 'system';
  }

  isInfluencerPictureUpdateEnabled() {
    return this.getCampaignWidgetSettingValue('allow_influencers_to_update_their_picture_in_widget');
  }

  syncInfluencerPictureFieldEnabledWithWidgetSetting() {
    if (!this.campaignMeta?.influencer_fields) {
      return;
    }

    const allowInfluencerPictureUpdate = this.isInfluencerPictureUpdateEnabled();
    this.campaignMeta.influencer_fields = this.campaignMeta.influencer_fields.map(field => {
      if (!this.isInfluencerPictureField(field)) {
        return field;
      }

      return {
        ...field,
        enabled: allowInfluencerPictureUpdate
      };
    });
  }

  isRequiredGenericInfluencerField(field) {
    return field?.field_type === 'primary' && this.requiredGenericInfluencerFieldKeys.includes(field.key);
  }

  isPrimaryInfoFieldDisplayLocked(field) {
    return this.isRequiredGenericInfluencerField(field) &&
      this.getCampaignWidgetSettingValue('allow_influencers_to_edit_primary_info');
  }

  isInfluencerFieldEnabledToggleDisabled(field) {
    return !this.campaignMeta?.['influencer_fields_active'] ||
      this.isPrimaryInfoFieldDisplayLocked(field) ||
      (this.isInfluencerVideoField(field) && this.isInfluencerVideoUpdateEnabled());
  }

  isInfluencerFieldConfigDisabled(field) {
    return !this.campaignMeta?.['influencer_fields_active'];
  }

  isInfluencerFieldValueConfigDisabled(field) {
    return this.isInfluencerFieldConfigDisabled(field) || !this.getInfluencerFieldEnabled(field);
  }

  getInfluencerFieldEnabled(field) {
    if (this.isInfluencerPictureField(field)) {
      return this.isInfluencerPictureUpdateEnabled();
    }

    if (this.isInfluencerVideoField(field) && this.isInfluencerVideoUpdateEnabled()) {
      return true;
    }

    if (this.isPrimaryInfoFieldDisplayLocked(field)) {
      return true;
    }

    return !!field.enabled;
  }

  getInfluencerFieldLabelMaxLength(field) {
    if (field?.field_type === 'custom' && field?.type === 'image') {
      return this.imageCustomFieldLabelMaxLength;
    }

    return null;
  }

  isImageCustomFieldLabelTooLong(field) {
    return field?.field_type === 'custom'
      && field?.type === 'image'
      && (field?.title?.trim() || '').length > this.imageCustomFieldLabelMaxLength;
  }

  showImageCustomFieldLabelMaxLengthError(field) {
    this.toastr.error(
      `Label for image custom field '${field.label.trim()}' must be `
      + `${this.imageCustomFieldLabelMaxLength} characters or fewer`
    );
  }

  onInfluencerFieldTypeChange(field, type) {
    field.type = type;
    field.defaultValue = type === 'color' ? this.getDefaultCustomFieldColor() : null;
    delete field.defaultValueEditorMode;

    if (field.field_type === 'custom' && type === 'video-recorder') {
      field.video_settings = this.normalizeInfluencerFieldVideoSettings(field.video_settings);
    } else if (Object.prototype.hasOwnProperty.call(field, 'video_settings')) {
      delete field.video_settings;
    }
    if (field.field_type === 'custom' && type === 'image') {
      field.image_settings = this.normalizeInfluencerFieldImageSettings(field.image_settings);
    } else if (Object.prototype.hasOwnProperty.call(field, 'image_settings')) {
      delete field.image_settings;
    }

    if (this.isImageCustomFieldLabelTooLong(field)) {
      this.showImageCustomFieldLabelMaxLengthError(field);
    }

    this.onSettingsChange(type);
  }

  onInfluencerFieldEnabledChange(field, value) {
    if (this.isInfluencerPictureField(field)) {
      field.enabled = this.isInfluencerPictureUpdateEnabled();
      return;
    }

    if (this.isPrimaryInfoFieldDisplayLocked(field)) {
      return;
    }

    field.enabled = value;
    this.onSettingsChange(value);
  }

  normalizeLockedInfluencerFields(fields) {
    return (fields || []).map(field => {
      if (this.isInfluencerPictureField(field)) {
        return {
          ...field,
          enabled: this.isInfluencerPictureUpdateEnabled()
        };
      }

      return field;
    });
  }

  validateInfluencerFieldsForSave() {
    this.campaignMeta.influencer_fields = this.normalizeLockedInfluencerFields(this.campaignMeta.influencer_fields);
    const customFields = _.cloneDeep(this.campaignMeta.influencer_fields);
    for (const customField of customFields) {
      delete customField.defaultValueEditorMode;

      if (this.isInfluencerPictureField(customField)) {
        customField.label = 'Headshot/logo';
        customField.title = customField.title?.trim() || customField.label || 'Headshot/logo';
        continue;
      }

      if (customField.field_type === 'primary') {
        customField.title = customField.title?.trim() || customField.label;
        continue;
      }

      if (customField.field_type !== 'custom') {
        continue;
      }

      customField.defaultValue = this.normalizeCustomFieldDefaultValue(customField);

      const titlePresent = customField.title?.trim() !== '' && customField.title;
      const typePresent = customField.type?.trim() !== '' && customField.type !== null;
      const defaultValuePresent = customField.defaultValue?.trim() !== '' && customField.defaultValue;
      const required = customField.required ?? false;

      if (customField.enabled) {
        if (!titlePresent) {
          this.toastr.error(`Please enter title for custom field '${customField.label.trim()}'`);
          return null;
        }

        if (!typePresent) {
          this.toastr.error(`Please select type for custom field '${customField.label.trim()}'`);
          return null;
        }

        if (this.isImageCustomFieldLabelTooLong(customField)) {
          this.showImageCustomFieldLabelMaxLengthError(customField);
          return null;
        }

        if (customField.read_only && required && !defaultValuePresent) {
          this.toastr.error(`Read-only required field '${customField.label.trim()}' must have a default value`);
          return null;
        }
      } else {
        customField.title = '';
        customField.type = 'text';
        customField.defaultValue = '';
        customField.required = false;
        customField.read_only = false;
        delete customField.video_settings;
        delete customField.image_settings;
      }

      if (customField.type === 'video-recorder') {
        customField.video_settings = this.normalizeInfluencerFieldVideoSettings(customField.video_settings);
      } else {
        delete customField.video_settings;
      }
      if (customField.type === 'image') {
        customField.image_settings = this.normalizeInfluencerFieldImageSettings(customField.image_settings);
      } else {
        delete customField.image_settings;
      }
    }

    return customFields;
  }

  loadSharePresets() {
    if (!this.campaign?.id) {
      return;
    }

    this.campaignSharePresetService.list(this.campaign.id)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((resp: any) => {
        if (resp?.success) {
          this.sharePresets = resp.data?.presets || [];
          this.sharePresetOptions = this.sharePresets;
          this.sharePresetPermissions = resp.data?.permissions || {};
          this.restoreSelectedSharePresetFromMeta();
          this.cdr.markForCheck();
        }
      }, error => this.toastr.error(this.loaderService.getErrorMessage(error)));
  }

  closeSharePresetSaveMenuOnOutsideClick() {
    if (this.sharePresetSaveMenuOpen) {
      this.sharePresetSaveMenuOpen = false;
    }
  }

  restoreSelectedSharePresetFromMeta() {
    const selectedPresetId = Number(this.campaignMeta?.selected_campaign_share_preset_id || null);
    this.selectedSharePresetId = Number.isFinite(selectedPresetId) && selectedPresetId > 0 ? selectedPresetId : null;
    this.selectedSharePreset = this.selectedSharePresetId
      ? this.sharePresets.find(preset => preset.id === this.selectedSharePresetId) || null
      : null;
  }

  clearSelectedSharePreset() {
    this.selectedSharePresetId = null;
    this.selectedSharePreset = null;
    if (this.campaignMeta) {
      this.campaignMeta.selected_campaign_share_preset_id = null;
    }
  }

  onSharePresetSelected(option: any, applyTemplate: any) {
    if (!option?.value) {
      this.selectedSharePresetId = null;
      this.selectedSharePreset = null;
      return;
    }

    const preset = this.sharePresets.find(item => item.id === option.value);
    if (!preset) {
      return;
    }

    this.openSharePresetApplyModal(preset, applyTemplate);
  }

  onSelectedSharePresetClicked(preset: any, applyTemplate: any) {
    if (!preset) {
      return;
    }

    this.openSharePresetApplyModal(preset, applyTemplate);
  }

  openSharePresetApplyModal(preset: any, applyTemplate: any) {
    const previousPresetId = this.campaignMeta?.selected_campaign_share_preset_id || null;
    this.selectedSharePresetId = preset.id;
    this.selectedSharePreset = preset;
    this.pendingSharePreset = preset;
    this.sharePresetApplySkips = {
      widget_ui_customization: false,
      meta_texts: false,
      share_image_design: false,
      custom_fields: false,
      custom_actions: false
    };
    const modalRef = this._modalService.open(applyTemplate, {
      centered: true,
      keyboard: true
    });
    modalRef.result.catch(() => {
      if (this.pendingSharePreset?.id === preset.id) {
        this.pendingSharePreset = null;
      }
      this.selectedSharePresetId = previousPresetId;
      this.selectedSharePreset = previousPresetId
        ? this.sharePresets.find(item => item.id === previousPresetId) || null
        : null;
      this.cdr.markForCheck();
    });
  }

  openSharePresetSaveModal(template: any) {
    this.sharePresetSubmitted = false;
    this.sharePresetSaveMenuOpen = false;
    this.sharePresetName = this.selectedSharePreset?.name || '';
    this.sharePresetDescription = this.selectedSharePreset?.description || '';
    this.sharePresetSections = {
      widget_ui_customization: true,
      meta_texts: true,
      share_image_design: true,
      custom_fields: true,
      custom_actions: true
    };
    this._modalService.open(template, {
      centered: true,
      keyboard: true
    });
  }

  toggleSharePresetSaveMenu(event: Event) {
    event.stopPropagation();
    this.sharePresetSaveMenuOpen = !this.sharePresetSaveMenuOpen;
  }

  saveSharePresetAsNew(modal: any, scope: 'public' | 'client' | 'project') {
    this.sharePresetSaveMenuOpen = false;
    this.persistSharePreset(modal, scope);
  }

  persistSharePreset(modal: any, scope: 'public' | 'client' | 'project', presetId: number = null) {
    this.sharePresetSubmitted = true;
    const name = (this.sharePresetName || '').trim();
    if (!name) {
      return;
    }

    const payload = this.buildSharePresetPayload();
    if (!payload) {
      return;
    }

    const body = {
      campaign_id: this.campaign.id,
      name,
      description: this.sharePresetDescription || '',
      scope,
      payload
    };
    const request = presetId
      ? this.campaignSharePresetService.update(presetId, body)
      : this.campaignSharePresetService.create(body);

    this.loaderService.show();
    request.pipe(
      map((resp: any) => {
        this.loaderService.hide();
        if (resp?.success) {
          modal.close();
          this.selectedSharePresetId = resp.data?.id || presetId;
          this.campaignMeta.selected_campaign_share_preset_id = this.selectedSharePresetId;
          this.keepSharePresetSelectionOnNextSettingsChange = true;
          this.onSettingsChange(null, 0, false);
          this.toastr.success('Preset saved');
          this.loadSharePresets();
          return;
        }
        this.toastr.error(this.loaderService.getErrorMessage(resp));
      }),
      catchError(error => {
        this.loaderService.hide(true);
        this.toastr.error(this.loaderService.getErrorMessage(error));
        return of(null);
      })
    ).subscribe(() => this.cdr.markForCheck());
  }

  deleteSharePreset(event: Event, preset: any) {
    event.preventDefault();
    event.stopPropagation();
    if (!preset?.can_delete) {
      return;
    }

    Swal.fire({
      title: 'Delete preset?',
      text: `Preset "${preset.name}" will be deleted.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then(result => {
      if (!result.value) {
        return;
      }

      this.campaignSharePresetService.delete(preset.id, this.campaign.id)
        .pipe(takeUntil(this.unsubscriber))
        .subscribe((resp: any) => {
          if (resp?.success) {
            if (this.selectedSharePresetId === preset.id) {
              this.clearSelectedSharePreset();
              this.onSettingsChange(null, 0, false);
              this.cdr.markForCheck();
            }
            this.loadSharePresets();
            return;
          }
          this.toastr.error(this.loaderService.getErrorMessage(resp));
        }, error => this.toastr.error(this.loaderService.getErrorMessage(error)));
    });
  }

  canCreateSharePresetScope(scope: 'public' | 'client' | 'project') {
    return !!this.sharePresetPermissions?.[`can_create_${scope}`];
  }

  buildSharePresetPayload() {
    const selected = this.sharePresetSections;
    const payload: any = {};

    if (!Object.values(selected).some(Boolean)) {
      this.toastr.error('Select at least one section to save');
      return null;
    }

    if (selected.meta_texts && !this.validateSocialMessage()) {
      this.changeToInvalidTab();
      return null;
    }

    if (selected.custom_fields) {
      const fields = this.validateInfluencerFieldsForSave();
      if (!fields) {
        return null;
      }
      payload.custom_fields = {
        influencer_fields_active: this.campaignMeta.influencer_fields_active ?? false,
        influencer_fields: fields
      };
    }

    if (selected.custom_actions) {
      const actionButtons = this.getValidatedActionButtons();
      if (!actionButtons) {
        return null;
      }
      payload.custom_actions = {
        action_buttons: actionButtons,
        action_buttons_active: this.campaignMeta.action_buttons_active,
        action_buttons_required: this.campaignMeta.action_buttons_required,
        action_buttons_no_action_message: this.campaignMeta.action_buttons_no_action_message,
        default_action_button_index: this.campaignMeta.default_action_button_index
      };
    }

    if (selected.widget_ui_customization) {
      payload.widget_ui_customization = {
        ...this.getSharePresetWidgetSettingsSnapshot(),
        social_networks: this.positions.map(pos => ({
          id: pos.id,
          active: this.socialPlatformVisibility[pos.id],
          order: pos.order,
          x: pos.x,
          y: pos.y
        }))
      };
    }

    if (selected.meta_texts) {
      payload.meta_texts = {
        title: this.campaignMeta.title,
        description: this.campaignMeta.description,
        social_networks: _.cloneDeep(this.socialMedias)
      };
    }

    if (selected.share_image_design) {
      payload.share_image_design = {
        image: this.campaignMeta.image,
        image_width: this.campaignMeta.image_width,
        image_height: this.campaignMeta.image_height,
        video: this.campaignMeta.video,
        video_width: this.campaignMeta.video_width,
        video_height: this.campaignMeta.video_height,
        share_media_order: [...this.shareMediaOrder],
        image_template: this.campaignMeta.image_template,
        share_video_duration: this.campaignMeta.share_video_duration ?? null
      };
    }

    return payload;
  }

  getSharePresetWidgetSettingsSnapshot() {
    const snapshot = this.sharePresetWidgetKeys.reduce((settings, key) => {
      settings[key] = this.campaignMeta?.[key] ?? this.sharePresetWidgetDefaults[key];
      return settings;
    }, {});
    return {...snapshot, widget_text_editor_modes: _.cloneDeep(this.campaignMeta.widget_text_editor_modes || {})};
  }

  applySharePresetWidgetSettings(widget: any) {
    this.campaignMeta.widget_text_editor_modes = _.cloneDeep(widget?.widget_text_editor_modes || {});
    this.sharePresetWidgetKeys.forEach(key => {
      this.campaignMeta[key] = widget && Object.prototype.hasOwnProperty.call(widget, key)
        ? widget[key]
        : this.sharePresetWidgetDefaults[key];
    });
    this.inheritUnsetCampaignWidgetFields();
    this.selectedWidgetAIAvatarTemplate = this.campaignMeta.widget_ai_avatar_template
      ? this.widgetAIAvatarTemplates.find(item => item.id === this.campaignMeta.widget_ai_avatar_template) || null
      : null;

    if (this.campaign?.project_id && this.getCampaignWidgetSettingValue('allow_influencers_to_use_ai_avatar_in_widget') && this.widgetAIAvatarTemplates.length === 0) {
      this.fetchWidgetAITemplates();
    }
  }

  applySharePreset(modal: any) {
    if (!this.pendingSharePreset?.payload) {
      modal.close();
      return;
    }

    const appliedPreset = this.pendingSharePreset;
    const payload = _.cloneDeep(appliedPreset.payload);
    const skips = this.sharePresetApplySkips;

    if (payload.widget_ui_customization && !skips.widget_ui_customization) {
      const widget = payload.widget_ui_customization;
      this.applySharePresetWidgetSettings(widget);
      (widget.social_networks || []).forEach(item => {
        const pos = this.positions.find(position => position.id === item.id);
        if (pos) {
          pos.order = item.order ?? pos.order;
          pos.x = item.x ?? pos.x;
          pos.y = item.y ?? pos.y;
          pos.active = item.active ?? pos.active;
          this.socialPlatformVisibility[item.id] = item.active ?? this.socialPlatformVisibility[item.id];
          if (this.socialMedias[item.id]) {
            this.socialMedias[item.id].active = this.socialPlatformVisibility[item.id];
          }
        }
      });
      this.rearrangeSocialNetworkPositions(this.panelWidth, this.positions);
    }

    if (payload.meta_texts && !skips.meta_texts) {
      this.campaignMeta.title = payload.meta_texts.title ?? this.campaignMeta.title;
      this.campaignMeta.description = payload.meta_texts.description ?? this.campaignMeta.description;
      this.socialMedias = {
        ...this.socialMedias,
        ..._.cloneDeep(payload.meta_texts.social_networks || {})
      };
    }

    if (payload.share_image_design && !skips.share_image_design) {
      Object.assign(this.campaignMeta, _.cloneDeep(payload.share_image_design));
      this.syncShareMediaOrderToMeta();
    }

    if (payload.custom_fields && !skips.custom_fields) {
      this.campaignMeta.influencer_fields_active = payload.custom_fields.influencer_fields_active ?? false;
      this.campaignMeta.influencer_fields = this.normalizeInfluencerFields(_.cloneDeep(payload.custom_fields.influencer_fields || []));
    }

    if (payload.custom_actions && !skips.custom_actions) {
      this.campaignMeta.action_buttons = _.cloneDeep(payload.custom_actions.action_buttons || []);
      this.campaignMeta.action_buttons_active = payload.custom_actions.action_buttons_active ?? false;
      this.campaignMeta.action_buttons_required = payload.custom_actions.action_buttons_required ?? false;
      this.campaignMeta.action_buttons_no_action_message = payload.custom_actions.action_buttons_no_action_message ?? '';
      this.campaignMeta.default_action_button_index = payload.custom_actions.default_action_button_index ?? 0;
    }

    modal.close();
    this.pendingSharePreset = null;
    this.selectedSharePresetId = appliedPreset.id;
    this.selectedSharePreset = appliedPreset;
    this.campaignMeta.selected_campaign_share_preset_id = appliedPreset.id;
    this.keepSharePresetSelectionOnNextSettingsChange = true;
    this.onSettingsChange(null, 0);
  }

  startResizing(event: PointerEvent) {
    startPanelResize(event, this.panelWidth, width => {
      this.panelWidth = width;
      this.rearrangeSocialNetworkPositions(this.panelWidth, this.positions);
      this.cdr.markForCheck();
    });
  }

  togglePanel() {
    this.panelCollapsed = !this.panelCollapsed;
    if (this.panelCollapsed) {
      this.panelWidth = 25;
    } else {
      this.panelWidth = this.defaultPanelWidth;
    }
  }

  dropActionButton(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.campaignMeta.action_buttons, event.previousIndex, event.currentIndex);
    this.onSettingsChange(null);
  }

  dropCustomField(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.campaignMeta.influencer_fields, event.previousIndex, event.currentIndex);
    this.onSettingsChange(null);
    this.clearInfluencerFieldDragTransforms();
  }

  clearInfluencerFieldDragTransforms() {
    if (typeof window === 'undefined') {
      return;
    }

    const clearTransforms = () => {
      const rows = this.elementRef.nativeElement.querySelectorAll<HTMLElement>(
        '.influencer-fields-table-body .influencer-fields-row'
      );
      rows.forEach((row) => {
        row.style.transform = '';
      });
    };

    window.requestAnimationFrame(() => {
      clearTransforms();
      window.setTimeout(clearTransforms, 250);
    });
  }

  onCustomFieldDefaultValueSelected(event, field) {
    field.defaultValue = event;
    this.onSettingsChange(null);
  }

  onCustomFieldActionValueSelected(event, field) {
    field.value = event;
    this.onSettingsChange(null);
  }

  onActionButtonIconSelected(event, button) {
    button.icon = event;
    this.onSettingsChange(null);
  }

  onSettingsChange(event, debounce = 2, reloadWidgetPreview = true) {
    // Nothing an expanded-section popup touches is saved until its Save button runs.
    if (this.expandedSectionKey) {
      return;
    }

    if (this.keepSharePresetSelectionOnNextSettingsChange) {
      this.keepSharePresetSelectionOnNextSettingsChange = false;
    } else if (this.selectedSharePresetId) {
      this.clearSelectedSharePreset();
    }

    // Marks this change as unsaved for hasUnsavedChanges() right away, before the debounce
    // (or any save) has a chance to run.
    this.changeSeq++;

    if (this.settingChangedDebounceTimer) {
      clearTimeout(this.settingChangedDebounceTimer);
    }

    // start new 2s timer
    this.settingChangedDebounceTimer = setTimeout(() => {
      this.settingChangedDebounceTimer = null;
      this.enqueueSave().then(status => {
        if (status === 'saved' && this.campaignMeta && reloadWidgetPreview) {
          this.loadPreviewInfluencers();

          const currentInfluencer = this.getCurrentInfluencer();
          if (this.campaignMeta['public_widget_enabled']) {
            this.getWidgetPreviewUrl(true, currentInfluencer?.id);
          } else {
            const influencerId = currentInfluencer?.is_generic ? undefined : currentInfluencer?.id;
            this.getWidgetPreviewUrl(false, influencerId);
          }
        }
        this.cdr.markForCheck();
      });
    }, debounce * 1000);
  }

  getCustomFields() {
    return this.campaignMeta.influencer_fields
      .filter(field => field.field_type === 'custom')
      .sort((a, b) => {
        if (a.key === 'custom_message') {
          return -1;
        }
        if (b.key === 'custom_message') {
          return 1;
        }

        const numA = parseInt(a.key.replace('custom_', ''), 10);
        const numB = parseInt(b.key.replace('custom_', ''), 10);

        return numA - numB;
      });
  }

  private readonly widgetProfilePictureAdvancedKeys = [
    'widget_profile_picture_min_width',
    'widget_profile_picture_min_height'
  ];

  private readonly widgetProfileVideoAdvancedKeys = [
    'widget_profile_video_enable_recorder',
    'widget_profile_video_min_duration',
    'widget_profile_video_max_duration',
    'widget_profile_video_min_width',
    'widget_profile_video_min_height',
    'widget_profile_video_target_aspect_width',
    'widget_profile_video_target_aspect_height',
    'widget_profile_video_caption_mode',
    'widget_profile_video_caption_let_user_decide',
    'widget_profile_video_caption_position',
    'widget_profile_video_caption_background_enabled',
    'widget_profile_video_caption_background_color',
    'widget_profile_video_caption_background_opacity',
    'widget_profile_video_caption_font_color',
    'widget_profile_video_caption_font_opacity',
    'widget_profile_video_caption_font_family',
    'widget_profile_video_caption_font_face',
    'widget_profile_video_caption_font_url',
    'widget_profile_video_background_mode',
    'widget_profile_video_background_let_user_decide',
    'widget_profile_video_background_color',
    'widget_profile_video_enable_teleprompter',
    'widget_profile_video_teleprompter_speed',
    'widget_profile_video_teleprompter_question'
  ];

  public selectedInfluencerFieldForImageSettings: any = null;

  public selectedInfluencerFieldImageSettings: any = null;

  public selectedInfluencerFieldForVideoSettings: any = null;

  public selectedInfluencerFieldVideoSettings: any = null;

  public influencerFieldInheritedSettingsMessage = '';

  // Starts the pending save so it has a chance to land before the tab actually closes, and
  // only asks the browser to confirm while a save is pending or in flight.
  private readonly beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    if (!this.hasUnsavedChanges()) {
      return;
    }
    this.flushPendingSave();
    event.preventDefault();
    event.returnValue = '';
  };

  private readonly videoRecorderMessageHandler = (event: MessageEvent) => {
    const data = event?.data;
    if (!data || typeof data !== 'object') {
      return;
    }

    if (data.name === 'snoballVideoRecorderPageMode') {
      this.setVideoRecorderPageMode(Boolean(data.active));
      this.cdr.markForCheck();
    }
  };

  public token = null;

  public fontBrowserUrl: SafeResourceUrl | null = null;

  public fontBrowserModalRef: NgbModalRef | null = null;

  public activeVideoCaptionFontSettingsTarget: any = null;

  readonly fontFileBrowser = viewChild<FileBrowserComponent>('fontFileBrowser');

  readonly fontBrowserShell = viewChild<IframeModalShellComponent>('fontBrowserShell');

  openWidgetAdvancedSettings(template: any) {
    this.settingsService.getSettingByKey(WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((response: any) => {
        this.applyWidgetAdvancedDefaultSettings(response?.data?.value);
        this.openWidgetAdvancedSettingsModal(template);
        this.cdr.markForCheck();
      }, () => {
        this.ensureCampaignWidgetAdvancedDefaults();
        this.openWidgetAdvancedSettingsModal(template);
        this.cdr.markForCheck();
      });
  }

  saveWidgetAdvancedSettings(modal: any) {
    this.ensureCampaignWidgetAdvancedDefaults();
    modal.close();
    this.onSettingsChange(null);
  }

  openInfluencerFieldInheritedSettings(field: any, template: any) {
    const settingSource = field?.type === 'video-recorder'
      ? 'Update Profile Video'
      : 'Update Profile Picture';
    this.influencerFieldInheritedSettingsMessage =
      `Settings for this field are inherited from ${settingSource} Advanced Settings in Widget Settings.`;
    this._modalService.open(template, {
      centered: true,
      keyboard: true,
      windowClass: 'widget-advanced-settings-window'
    });
  }

  openInfluencerFieldVideoSettings(field: any, template: any) {
    this.selectedInfluencerFieldForVideoSettings = field;
    field.video_settings = this.normalizeInfluencerFieldVideoSettings(field.video_settings);
    this.selectedInfluencerFieldVideoSettings = _.cloneDeep(field.video_settings);
    this._modalService.open(template, {
      centered: true,
      keyboard: true,
      scrollable: true,
      windowClass: 'widget-advanced-settings-window'
    });
  }

  saveInfluencerFieldVideoSettings(modal: any) {
    if (this.selectedInfluencerFieldForVideoSettings) {
      this.selectedInfluencerFieldForVideoSettings.video_settings = this.normalizeInfluencerFieldVideoSettings(
        this.selectedInfluencerFieldVideoSettings
      );
    }
    modal.close();
    this.selectedInfluencerFieldForVideoSettings = null;
    this.selectedInfluencerFieldVideoSettings = null;
    this.onSettingsChange(null);
  }

  openInfluencerFieldImageSettings(field: any, template: any) {
    this.selectedInfluencerFieldForImageSettings = field;
    field.image_settings = this.normalizeInfluencerFieldImageSettings(field.image_settings);
    this.selectedInfluencerFieldImageSettings = _.cloneDeep(field.image_settings);
    this._modalService.open(template, {
      centered: true,
      keyboard: true,
      scrollable: true,
      windowClass: 'widget-advanced-settings-window'
    });
  }

  saveInfluencerFieldImageSettings(modal: any) {
    if (this.selectedInfluencerFieldForImageSettings) {
      this.selectedInfluencerFieldForImageSettings.image_settings = this.normalizeInfluencerFieldImageSettings(
        this.selectedInfluencerFieldImageSettings
      );
    }
    modal.close();
    this.selectedInfluencerFieldForImageSettings = null;
    this.selectedInfluencerFieldImageSettings = null;
    this.onSettingsChange(null);
  }

  openVideoCaptionFontBrowser(settingsTarget: any, template: any) {
    this.activeVideoCaptionFontSettingsTarget = settingsTarget;
    const theme = document.body.classList.contains('dark-theme') ? 'dark' : 'light';
    const appContext = { token: this.token, projectId: this.campaign?.project_id || null };
    const url = `${environment.apiUrl}/share/font-browser/show?appcontext=${encodeURIComponent(JSON.stringify(appContext))}&theme=${theme}&requireRemoteFont=true`;
    this.fontBrowserUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.fontBrowserModalRef = this._modalService.open(template, {
      centered: false,
      size: 'xl',
      keyboard: true,
      windowClass: 'widget-font-browser-modal'
    });
  }

  onFontBrowserFileSelected(url: string | null) {
    if (!url) {
      return;
    }

    const iframeWindow =
      this.fontBrowserShell()?.iframe()?.nativeElement?.contentWindow ||
      (document.querySelector('.widget-font-browser-modal iframe') as HTMLIFrameElement | null)?.contentWindow;
    iframeWindow?.postMessage({
      origin: 'parent',
      action: 'fontFileSelected',
      url
    }, '*');
  }

  getVideoCaptionFontLabel(settingsTarget: any) {
    return settingsTarget?.['widget_profile_video_caption_font_family'] || 'Default caption font';
  }

  clearVideoCaptionFont(settingsTarget: any) {
    settingsTarget['widget_profile_video_caption_font_family'] = '';
    settingsTarget['widget_profile_video_caption_font_face'] = '';
    settingsTarget['widget_profile_video_caption_font_url'] = '';
  }

  private handleFontBrowserMessage = (event: MessageEvent) => {
    const data = typeof event.data === 'string' ? this.tryParseMessageData(event.data) : event.data;
    if (!data || data.origin !== 'fontBrowser') {
      return;
    }

    if (data.action === 'fontSelected') {
      this.applyVideoCaptionFontSelection(data);
      this.fontBrowserModalRef?.close();
      this.fontBrowserModalRef = null;
      this.activeVideoCaptionFontSettingsTarget = null;
    } else if (data.action === 'openFileBrowser') {
      this.fontFileBrowser()?.openFileBrowser();
    }
    this.cdr.markForCheck();
  };

  private applyVideoCaptionFontSelection(data: any) {
    const fontName = `${data.fontFamily || ''}`.trim();
    const target = this.activeVideoCaptionFontSettingsTarget || this.campaignMeta;
    if (!fontName || !target) {
      return;
    }

    const fontFace = `${data.fontFace || data.fontStyle || ''}`.trim();
    const fontUrl = this.getFontUrlFromFontFace(fontFace);
    if (fontFace && !fontUrl) {
      this.toastr.warning('This font is only available on your computer. Upload a woff/woff2 font or choose a web font so saved videos can render it.', 'Font not available for server render');
      return;
    }

    target['widget_profile_video_caption_font_family'] = fontName;
    target['widget_profile_video_caption_font_face'] = fontFace;
    target['widget_profile_video_caption_font_url'] = fontUrl;
  }

  private getFontUrlFromFontFace(fontFace: string) {
    const match = `${fontFace || ''}`.match(/url\((['"]?)(.*?)\1\)/i);
    return match?.[2] || '';
  }

  private tryParseMessageData(raw: string) {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  hasInfluencerFieldSettingsButton(field: any) {
    return field?.type === 'image' || field?.type === 'video-recorder';
  }

  canEditInfluencerFieldVideoSettings(field: any) {
    return field?.field_type === 'custom' && field?.type === 'video-recorder';
  }

  hasInfluencerFieldVideoSettings(field: any) {
    return this.canEditInfluencerFieldVideoSettings(field) && !!field?.video_settings;
  }

  canEditInfluencerFieldImageSettings(field: any) {
    return field?.field_type === 'custom' && field?.type === 'image';
  }

  hasInfluencerFieldImageSettings(field: any) {
    return this.canEditInfluencerFieldImageSettings(field) && !!field?.image_settings;
  }

  hasInfluencerFieldEditableSettings(field: any) {
    return this.hasInfluencerFieldVideoSettings(field) || this.hasInfluencerFieldImageSettings(field);
  }

  canEditInfluencerFieldSettings(field: any) {
    return this.canEditInfluencerFieldVideoSettings(field) || this.canEditInfluencerFieldImageSettings(field);
  }

  onInfluencerFieldSettingsClick(field: any, videoTemplate: any, imageTemplate: any, inheritedTemplate: any) {
    if (this.canEditInfluencerFieldVideoSettings(field)) {
      this.openInfluencerFieldVideoSettings(field, videoTemplate);
      return;
    }

    if (this.canEditInfluencerFieldImageSettings(field)) {
      this.openInfluencerFieldImageSettings(field, imageTemplate);
      return;
    }

    this.openInfluencerFieldInheritedSettings(field, inheritedTemplate);
  }

  private ensureCampaignWidgetAdvancedDefaults() {
    const advancedKeys = [
      ...this.widgetProfilePictureAdvancedKeys,
      ...this.widgetProfileVideoAdvancedKeys
    ];

    if (!this.campaignMeta) {
      this.campaignMeta = {};
    }
    if (
      !Object.prototype.hasOwnProperty.call(this.campaignMeta, 'widget_profile_picture_min_height') &&
      Object.prototype.hasOwnProperty.call(this.campaignMeta, 'widget_profile_picture_max_height')
    ) {
      this.campaignMeta['widget_profile_picture_min_height'] = this.campaignMeta['widget_profile_picture_max_height'];
    }
    advancedKeys.forEach(key => {
      const defaultValue = (this.sharePresetWidgetDefaults as any)[key];
      if (!Object.prototype.hasOwnProperty.call(this.campaignMeta, key)) {
        this.campaignMeta[key] = defaultValue;
      }
    });
    delete this.campaignMeta['widget_profile_picture_max_height'];
    if (
      !(Number(this.campaignMeta['widget_profile_video_min_height']) > 0) &&
      Object.prototype.hasOwnProperty.call(this.campaignMeta, 'widget_profile_video_max_height')
    ) {
      this.campaignMeta['widget_profile_video_min_height'] = this.campaignMeta['widget_profile_video_max_height'];
    }
    this.campaignMeta['widget_profile_video_caption_mode'] = this.normalizeWidgetVideoMode(
      this.campaignMeta['widget_profile_video_caption_mode'],
      this.campaignMeta['widget_profile_video_caption_let_user_decide']
    );
    this.campaignMeta['widget_profile_video_caption_position'] = this.normalizeWidgetCaptionPosition(
      this.campaignMeta['widget_profile_video_caption_position']
    );
    this.campaignMeta['widget_profile_video_caption_background_enabled'] = this.coerceWidgetBoolean(
      this.campaignMeta['widget_profile_video_caption_background_enabled']
    );
    this.campaignMeta['widget_profile_video_background_mode'] = this.normalizeWidgetVideoMode(
      this.campaignMeta['widget_profile_video_background_mode'],
      this.campaignMeta['widget_profile_video_background_let_user_decide']
    );
    this.campaignMeta['widget_profile_video_caption_let_user_decide'] = false;
    this.campaignMeta['widget_profile_video_background_let_user_decide'] = false;
  }

  private loadWidgetAdvancedDefaultSettings() {
    this.settingsService.getSettingByKey(WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((response: any) => {
        this.applyWidgetAdvancedDefaultSettings(response?.data?.value);
        this.cdr.markForCheck();
      }, () => {});
  }

  private openWidgetAdvancedSettingsModal(template: any) {
    this._modalService.open(template, {
      centered: true,
      keyboard: true,
      scrollable: true,
      windowClass: 'widget-advanced-settings-window'
    });
  }

  private applyWidgetAdvancedDefaultSettings(value: any) {
    const defaults = this.flattenWidgetAdvancedDefaults(value);
    if (Object.keys(defaults).length > 0) {
      Object.assign(this.sharePresetWidgetDefaults, defaults);
    }
    this.ensureCampaignWidgetAdvancedDefaults();
  }

  private flattenWidgetAdvancedDefaults(value: any) {
    if (!value) {
      return {};
    }

    let parsed = value;
    if (typeof parsed === 'string') {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        return {};
      }
    }

    return {
      ...(parsed.image || {}),
      ...(parsed.video || {})
    };
  }

  private buildDefaultInfluencerFieldVideoSettings() {
    this.ensureCampaignWidgetAdvancedDefaults();
    return this.widgetProfileVideoAdvancedKeys.reduce((settings, key) => {
      settings[key] = this.campaignMeta?.[key] ?? (this.sharePresetWidgetDefaults as any)[key];
      return settings;
    }, {});
  }

  private buildDefaultInfluencerFieldImageSettings() {
    this.ensureCampaignWidgetAdvancedDefaults();
    return this.widgetProfilePictureAdvancedKeys.reduce((settings, key) => {
      settings[key] = this.campaignMeta?.[key] ?? (this.sharePresetWidgetDefaults as any)[key];
      return settings;
    }, {});
  }

  private normalizeInfluencerFieldImageSettings(settings: any = null) {
    const normalized = {
      ...this.buildDefaultInfluencerFieldImageSettings(),
      ...(settings || {})
    };

    if (
      !(Number(normalized['widget_profile_picture_min_height']) > 0) &&
      Object.prototype.hasOwnProperty.call(normalized, 'widget_profile_picture_max_height')
    ) {
      normalized['widget_profile_picture_min_height'] = normalized['widget_profile_picture_max_height'];
    }
    delete normalized['widget_profile_picture_max_height'];
    normalized['widget_profile_picture_min_width'] = Math.max(
      0,
      Number(normalized['widget_profile_picture_min_width']) || 0
    );
    normalized['widget_profile_picture_min_height'] = Math.max(
      0,
      Number(normalized['widget_profile_picture_min_height']) || 0
    );

    return normalized;
  }

  private normalizeInfluencerFieldVideoSettings(settings: any = null) {
    const normalized = {
      ...this.buildDefaultInfluencerFieldVideoSettings(),
      ...(settings || {})
    };

    if (
      !(Number(normalized['widget_profile_video_min_height']) > 0) &&
      Object.prototype.hasOwnProperty.call(normalized, 'widget_profile_video_max_height')
    ) {
      normalized['widget_profile_video_min_height'] = normalized['widget_profile_video_max_height'];
    }
    normalized['widget_profile_video_caption_mode'] = this.normalizeWidgetVideoMode(
      normalized['widget_profile_video_caption_mode'],
      normalized['widget_profile_video_caption_let_user_decide']
    );
    normalized['widget_profile_video_caption_position'] = this.normalizeWidgetCaptionPosition(
      normalized['widget_profile_video_caption_position']
    );
    normalized['widget_profile_video_caption_background_enabled'] = this.coerceWidgetBoolean(
      normalized['widget_profile_video_caption_background_enabled']
    );
    normalized['widget_profile_video_background_mode'] = this.normalizeWidgetVideoMode(
      normalized['widget_profile_video_background_mode'],
      normalized['widget_profile_video_background_let_user_decide']
    );
    normalized['widget_profile_video_caption_let_user_decide'] = false;
    normalized['widget_profile_video_background_let_user_decide'] = false;

    return normalized;
  }

  private normalizeWidgetVideoMode(value: any, letUserDecide: any) {
    if (letUserDecide === true || letUserDecide === 'true' || letUserDecide === 1 || letUserDecide === '1') {
      return 'let_user_decide';
    }

    const normalized = `${value || ''}`.toLowerCase();
    if (normalized === 'let_user_decide') {
      return 'let_user_decide';
    }
    if (['disabled', 'off', 'none', 'false'].includes(normalized)) {
      return 'disabled';
    }
    return 'auto';
  }

  private normalizeWidgetCaptionPosition(value: any) {
    const normalized = `${value || ''}`.toLowerCase();
    return ['top', 'center', 'bottom'].includes(normalized) ? normalized : 'bottom';
  }

  isInfluencerVideoField(field) {
    return field?.key === 'influencer_video' && field?.field_type === 'system';
  }

  isInfluencerVideoUpdateEnabled() {
    return this.getCampaignWidgetSettingValue('allow_influencers_to_update_their_video_in_widget');
  }

  syncInfluencerVideoFieldEnabledWithWidgetSetting() {
    if (!this.campaignMeta?.influencer_fields) {
      return;
    }

    const allowInfluencerVideoUpdate = this.isInfluencerVideoUpdateEnabled();
    this.campaignMeta.influencer_fields = this.campaignMeta.influencer_fields.map(field => {
      if (!this.isInfluencerVideoField(field)) {
        return field;
      }

      return {
        ...field,
        enabled: allowInfluencerVideoUpdate,
        read_only: allowInfluencerVideoUpdate ? false : field.read_only
      };
    });
  }
}
